<my-content placeholder="navigation">
  <div class="container-fluid">
    <div class="page-heading d-flex align-items-center justify-content-between my-4 px-2">
      {{ TypeHeader }}
      <span class="page-status text-danger">{{ PageStatus }}</span>
      <button class="btn btn-outline-primary" title="Go Back" (click)="goBack()">
        <i class="fa fa-arrow-left"></i> Back
      </button>
    </div>

    <form  [formGroup]="addFormNotice" (ngSubmit)="onHeaderSubmit(addFormNotice.value); ">
    <div class="card rounded-4 border-0">
      <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-4">
              <label for="Type" class="form-label">{{captionType}} <span class="text-danger">*</span></label>
              <ng-select [items]="[{id: '1', name: Sent}, {id: '0', name: Received}]" bindLabel="name" bindValue="id"
                formControlName="Notice" [clearable]="false" [placeholder]="'Select'+ captionType"></ng-select>
                @if (f.Notice.touched && f.Notice.invalid) {
                  @if (f.Notice.errors?.['required']) {
                    <div class="text-danger">
                      <small>{{captionType}} is required.</small>
                    </div>
                  }
                }
            </div>
            <div class="col-12 col-md-4">
              <label for="Section" class="form-label"><a routerLink="{{ RouteGMSection }}" target="_blank">{{captionSection}}</a>
                <span class="text-danger">*</span></label>
              <ng-select [items]="SectionList" bindLabel="MainDescr" bindValue="hdID" formControlName="Section"
                [clearable]="false" [placeholder]="'Select'+captionSection" bindLabel="MainDescr"></ng-select>
                @if (f.Section.touched && f.Section.invalid) {
                  <div class="text-danger">
                    @if (f.Section.errors?.['required']) {
                      <small>{{captionSection}} is required.</small>
                    }
                  </div>
                }
            </div>
            <div class="col-12 col-md-4">
              <label for="FIRNo" class="form-label">{{ FIRNo }} <span class="text-danger">*</span> </label>
              <input type="text" class="form-control" formControlName="FIRNo" placeholder="Enter {{ FIRNo }}" />
              @if (f.FIRNo.touched && f.FIRNo.invalid) {
                <div class="text-danger">
                  @if (f.FIRNo.errors?.['required']) {
                    <small>{{ FIRNo }} is required.</small>
                  }
                </div>
              }
            </div>
            <div class="col-12 col-md-4">
              <label for="eCoutrtType" class="form-label">e-Court Type</label>
              <ng-select [items]="EcourtTypeId" bindLabel="MainDescr" bindValue="hdID" (change)="onCourtSelect($event)"
                formControlName="EcourtTypeId"  placeholder="Select e-Court Type"></ng-select>
            </div>
            <div class="col-12 col-md-4">
              <label for="CourtName" class="form-label">{{CourtName}} </label>
              <input type="text" class="form-control" formControlName="EcourtNo" placeholder="Enter e-Court Name" />
            </div>
            <div class="col-12 col-md-4">
              <label for="caseCode" class="form-label"> {{captionCaseCode}} </label>
              <input type="text" class="form-control" formControlName="OriginalrefNo" [placeholder]="'Enter '+captionCaseCode" />
            </div>
            <div class="col-12 col-md-4">
              <label for="RefNo" class="form-label">{{ RefNo }} <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="RefNo" placeholder="Enter {{ RefNo }}" />
              @if (f.RefNo.touched && f.RefNo.invalid) {
                <div class="text-danger">
                  @if (f.RefNo.errors?.['required']) {
                    <small>{{ RefNo }} is required.</small>
                  }
                </div>
              }
            </div>
            <div class="col-12 col-md-4">
              <label for="ShortName" class="form-label">{{ CaptionShortName }} <span class="text-danger">*</span> </label>
              <input type="text" class="form-control" formControlName="ShortName"
                placeholder="Enter {{ CaptionShortName }}" />
              @if (f.ShortName.touched && f.ShortName.invalid) {
                <div class="text-danger">
                  @if (f.ShortName.errors?.['required']) {
                    <small>{{ CaptionShortName }} is required.</small>
                  }
                </div>
              }
            </div>
            <div class="col-12 col-md-4">
              <label for="Manager" class="form-label"><a routerLink="{{ RouteUserMaster }}" target="_blank">{{captionManager}}</a>
                <span class="text-danger">*</span></label>
              <ng-select [items]="Manager" bindLabel="name" bindValue="id1" formControlName="Manager"
                [clearable]="false" placeholder="Select {{captionManager}}"></ng-select>
                @if (f.Manager.touched && f.Manager.invalid) {
                  <div class="text-danger">
                    @if (f.Manager.errors?.['required']) {
                      <small>{{captionManager}} is required.</small>
                    }
                  </div>
                }
            </div>
            <div class="col-12 col-md-4">
              <label for="Category" class="form-label"><a routerLink="{{ RouteGMCategory }}"
                  target="_blank">{{captionCategory}}</a>
                <span class="text-danger">*</span></label>
              <ng-select [items]="Category" bindLabel="MainDescr" bindValue="hdID" formControlName="Category" 
                [clearable]="false" (change)="onCategorySelect($event)" placeholder="Select {{captionCategory}}"></ng-select>
                @if (f.Category.touched && f.Category.invalid) {
                  <div class="text-danger">
                    @if (f.Category.errors?.['required']) {
                      <small>{{captionCategory}} is required.</small>
                    }
                  </div>
                }
            </div>
            <div class="col-12 col-md-4">
              <label for="SubCategory" class="form-label">
                <a routerLink="{{ RouteGMSubCategory }}" target="_blank">{{captionSubCategory}}</a>
                <span class="text-danger">*</span></label>
              <ng-select [items]="SubCategory" bindLabel="MainDescr" bindValue="hdID" formControlName="SubCategory"
                [clearable]="false" placeholder="Select {{captionSubCategory}}"></ng-select>
                @if (f.SubCategory.touched && f.SubCategory.invalid) {
                  <div class="text-danger">
                    @if (f.SubCategory.errors?.['required']) {
                      <small>{{captionSubCategory}} is required.</small>
                    } 
                  </div>
                }
            </div>
            @if (str1 === 'Project') {
            <div class="col-12 col-md-4">
              <label for="Project" class="form-label"><a routerLink="{{ RouteGMDepartment }}"
                  target="_blank">{{captionProject}} 1212</a>
                <span class="text-danger">*</span></label>
              <ng-select [items]="Department" bindLabel="MainDescr" bindValue="hdID" formControlName="Department"
                [clearable]="false" placeholder="Select {{captionProject}}"></ng-select>
                @if (f.Department.touched && f.Department.invalid) {
                  <div class="text-danger">
                    @if (f.Department.errors?.['required']) {
                      <small>{{captionProject}} is required.</small>
                    }
                  </div>
                  }
            </div>
            }@else {
            <div class="col-12 col-md-4">
              <label for="Company" class="form-label"><a routerLink="{{ RouteCompany }}" target="_blank">{{captionCompany}}</a>
                <span class="text-danger">*</span></label>
              <ng-select [items]="Company" bindLabel="Name" bindValue="ID" formControlName="Company" [clearable]="false"
                placeholder="Select {{captionCompany}}"></ng-select>
                @if (f.Company.touched && f.Company.invalid) {
                  <div class="text-danger">
                    @if (f.Company.errors?.['required']) {
                      <small>{{captionCompany}} is required.</small>
                    }
                  </div>
                  }
            </div>
            <div class="col-12 col-md-4">
              <label for="Company">
                <a routerLink="{{ RouteGMDepartment }}" target="_blank">{{captionDepartment}}</a>
                <span class="text-danger">*</span></label>
              <ng-select [items]="Department" bindLabel="MainDescr" bindValue="hdID" formControlName="Department"
                [clearable]="false" placeholder="Select {{captionDepartment}}"></ng-select>
                @if (f.Department.touched && f.Department.invalid) {
                  <div class="text-danger">
                    @if (f.Department.errors?.['required']) {
                      <small>{{captionDepartment}} is required.</small>
                    }
                  </div>
                  }
            </div>

            }
            <div class="col-12 col-md-4">
              <label for="Leader" class="form-label"><a routerLink="{{ RouteUserMaster }}" target="_blank">{{captionLeader}}</a> 
                <span class="text-danger">*</span>
               </label>
              <ng-select [items]="Manager" bindLabel="name" bindValue="id1" formControlName="Leader" [clearable]="false"
                placeholder="Select {{captionLeader}}"></ng-select>
                @if (f.Leader.touched && f.Leader.invalid) {
                  <div class="text-danger">
                    @if (f.Leader.errors?.['required']) {
                      <small>{{captionLeader}} is required.</small>
                    }
                  </div>
                }
            </div>
            <div class="col-12 col-md-4">
              <label for="DateofNotice" class="form-label">Date of filling of {{ Type }} <span
                  class="text-danger">*</span></label>
              <mat-form-field class="fullwidth" appearance="outline">
                <input matInput [min]="minDate" formControlName="DateofNotice" [max]="maxDate" [matDatepicker]="picker"
                  placeholder="Choose a date" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              @if (f.Leader.touched && f.Leader.invalid) {
                <mat-error>
                  @if (f.DateofNotice.errors?.['required']) {
                    <small>Date of filling of {{ Type }} is required.</small>
                  }
                </mat-error>
              }
            </div>
            <div class="col-12 col-md-4">
              <label for="State" class="form-label"><a routerLink="{{ RouteGMState }}" target="_blank">{{captionState}}</a>
                <span class="text-danger">*</span></label>
              <ng-select [items]="State" bindLabel="MainDescr" bindValue="hdID" formControlName="State"
                [clearable]="false" (change)="onStateSelect($event)" placeholder="Select {{captionState}}"></ng-select>
                @if (f.State.touched && f.State.invalid) {
                  <div class="text-danger">
                    @if (f.State.errors?.['required']) {
                      <small>{{captionState}} is required.</small>
                    }
                  </div>
                }
            </div>
            <div class="col-12 col-md-4">
              <label for="Status" class="form-label">
                <a *ngIf="this.TypeHeader == 'Notice'" routerLink="{{ RouteGMNoticeStatus }}" target="_blank">{{captionStatus}}</a>
                <a *ngIf="this.TypeHeader == 'Case'" routerLink="{{ RouteGMCaseStatus }}" target="_blank">{{captionStatus}}</a>
                <span class="text-danger">*</span></label>
              <ng-select [items]="Stages" bindLabel="MainDescr" bindValue="hdID" formControlName="Stages"
                [clearable]="false" placeholder="Select {{captionStatus}}"></ng-select>
                @if (f.Stages.touched && f.Stages.invalid) {
                  <div class="text-danger">
                    @if (f.Stages.errors?.['required']) {
                      <small>{{captionStatus}} is required.</small>
                    }
                  </div>
                }
            </div>
            <div class="col-12 col-md-4">
              <label for="DateofReceiving" class="form-label">{{ CaptionDateofReceiving }} <span
                  class="text-danger">*</span></label>
              <mat-form-field class="fullwidth" appearance="outline">
                <input matInput  formControlName="DateofReceiving" [max]="maxDate"
                  [matDatepicker]="picker1" placeholder="Choose a date" />
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
              @if (f.DateofReceiving.touched && f.DateofReceiving.invalid) {
                <mat-error>
                  @if (f.DateofReceiving.errors?.['required']) {
                    <small>{{ CaptionDateofReceiving }} is required.</small>
                  }
                </mat-error>
              }
            </div>
            <div class="col-12 col-md-4">
              <label for="City" class="form-label"><a routerLink="{{ RouteGMCity }}" target="_blank">{{captionCity}}</a>
                <span class="text-danger">*</span></label>
              <ng-select [items]="City" bindLabel="MainDescr" bindValue="hdID" formControlName="City"
                [clearable]="false" (change)="onCitySelect($event)" placeholder="Select {{captionCity}}"></ng-select>
                @if (f.City.touched && f.City.invalid) {
                  <div class="text-danger">
                    @if (f.City.errors?.['required']) {
                      <small>{{captionCity}} is required.</small>
                    }
                  </div>
                }
            </div>
            <div class="col-12 col-md-4">
              <label for="Seriousness" class="form-label">{{captionSeriousness}}</label>
              <ng-select [items]="Seriousness" bindLabel="SubDescr" bindValue="SubID" formControlName="Seriousness"
                [clearable]="false" placeholder="Select {{captionSeriousness}}"></ng-select>
                @if (f.Seriousness.touched && f.Seriousness.invalid) {
                  <div class="text-danger">
                    @if (f.Seriousness.errors?.['required']) {
                      <small>{{captionSeriousness}} is required.</small>
                    }
                  </div>
                }
            </div>
            <div class="col-12 col-md-4">
              <label for="TargetDate" class="form-label"> {{captionTargetDate}} <span class="text-danger">*</span></label>
              <mat-form-field class="fullwidth" appearance="outline">
                <input matInput [min]="minDate" formControlName="TargetDate" [max]="maxDate" [matDatepicker]="picker2"
                  placeholder="Choose a date" />
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
              @if (f.TargetDate.touched && f.TargetDate.invalid) {
                <mat-error>
                  @if (f.TargetDate.errors?.['required']) {
                    <small>{{captionTargetDate}} is required.</small>
                  }
                </mat-error>
              }
            </div>
            <div class="col-12 col-md-4">
              <label for="Jurisdiction" class="form-label"><a routerLink="{{ RouteGMJurisdiction }}" target="_blank">{{
                  CaptionJurisdiction }}</a> </label>
              <ng-select [items]="Jurisdiction" bindLabel="MainDescr" bindValue="hdID" formControlName="Jurisdiction"
                [clearable]="false" placeholder="Select {{CaptionJurisdiction}}"></ng-select>
            </div>
            <div class="col-12 col-md-4">
              <label for="ExposureAmmount" class="form-label">{{ CaptionExposurAmount }} <span class="text-danger">*</span></label>
              <input class="form-control" formControlName="ExposureAmmount" placeholder="Exposure {{CaptionExposurAmount}}" step="0.01"
                (keyup)="onChangeExposureAmount($event.target.value)" name="exposureamount" type="number" />
              @if (f.ExposureAmmount.touched && f.ExposureAmmount.invalid) {
                <div class="text-danger">
                  @if (f.ExposureAmmount.errors?.['required']) {
                    <small>{{ CaptionExposurAmount }} is required.</small>
                  }
                </div>
              }
            </div>
            @if (TypeHeader == 'Case') {
            @if (str1 != 'Project') {
             @if (Type == 'Case' && BenchCase == '1' || Type == 'Notice' && BenchNotice == '1') {
            <div class="col-12 col-md-4">
              <label for="BenchNo" class="form-label">{{captionBench}} captionbranch <span class="text-danger">*</span> </label>
              <input type="text" class="form-control" formControlName="BenchNo" placeholder="Enter {{captionBench}}" />
              @if (f.BenchNo.touched && f.BenchNo.invalid) {
                <div class="text-danger">
                  @if (f.BenchNo.errors?.['required']) {
                    <small>{{captionBench}} is required.</small>
                  }
                </div>
                }
              </div>
            }
            }
            <div class="col-12 col-md-4">
              <label for="JudgeName" class="form-label">{{ JudgeName }} <span class="text-danger">*</span> </label>
              <input type="text" class="form-control" formControlName="JudgeName" placeholder="Enter Judge Name" />
              @if (f.JudgeName.touched && f.JudgeName.invalid) {
                <div class="text-danger">
                  @if (f.JudgeName.errors?.['required']) {
                    <small>{{ JudgeName }} is required.</small>
                  }
                </div>
                }
            </div>
            <div class="col-12 col-md-4">
              <label for="lawyerName" class="form-label"><a routerLink="/addorgcontact/1/0" target="_blank">{{ captionLawyer }}</a> <span class="text-danger">*</span> </label>
              <ng-select [items]="Lawyer" bindLabel="Name" bindValue="ContactID" formControlName="Lawyer"
                [clearable]="false" placeholder="Select {{ captionLawyer }}"></ng-select>
              @if (f.Lawyer.touched && f.Lawyer.invalid) {
                <div class="text-danger">
                  @if (f.Lawyer.errors?.['required']) {
                    <small>{{captionLawyer}} is required.</small>
                  }
                </div>
                }
            </div>
            @if (str1 == 'Project') {
            <div class="col-12 col-md-4">
              <label for="InvestigatingOfficer" class="form-label">{{InvestigatingOfficer}} <span class="text-danger">*</span> </label>
              <input class="form-control" formControlName="InvestigatingOfficer"
                placeholder="Enter {{ InvestigatingOfficer }}" name="OfficerName" type="text" value="" />
              @if (f.InvestigatingOfficer.touched && f.InvestigatingOfficer.invalid) {
                <div class="text-danger">
                  @if (f.InvestigatingOfficer.errors?.['required']) {
                    <small>{{InvestigatingOfficer}} is required.</small>
                  }
                </div>
                }
            </div>
            }
            }
            <div class="col-12 col-md-4">
              <label for="DueDate"> {{ DueDate }} <span class="text-danger">*</span></label>
              <mat-form-field class="fullwidth" appearance="outline">
                <input matInput [min]="minDate" formControlName="DueDate" [max]="maxDate" [matDatepicker]="picker3"
                  placeholder="Choose a date" />
                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                <mat-datepicker #picker3></mat-datepicker>
              </mat-form-field>
              @if (f.DueDate.touched && f.DueDate.invalid) {
                <mat-error>
                  @if (f.DueDate.errors?.['required']) {
                    {{DueDate}} is required.
                  }
                </mat-error>
                }
            </div>
            <div class="col-12 col-md-4">
              <label for="LastDate"> {{ LastDate }} <span class="text-danger">*</span></label>
              <mat-form-field class="fullwidth" appearance="outline">
                <input matInput [min]="minDate" formControlName="LastDate" [max]="maxDate" [matDatepicker]="picker4"
                  placeholder="Choose a date" />
                <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                <mat-datepicker #picker4></mat-datepicker>
              </mat-form-field>
              @if (f.LastDate.touched && f.LastDate.invalid) {
                <mat-error>
                  @if (f.LastDate.errors?.['required']) {
                    {{LastDate}} is required.
                  }
                </mat-error>
                }
            </div>
            @if ((Type == 'Case' && CourtNumberCase == '1') || (Type == 'Notice' && CourtNumberNotice == '1')) {
            <div class="col-12 col-md-4">
              <label for="CourtNumber" class="form-label">{{ captionCourtNumber }} <span class="text-danger">*</span> </label>
              <input type="text" class="form-control" formControlName="CourtNumber" placeholder="Enter {{ captionCourtNumber }}" />
              @if (f.CourtNumber.touched && f.CourtNumber.invalid) {
                <div class="text-danger">
                  @if (f.CourtNumber.errors?.['required']) {
                    <small>{{captionCourtNumber}} is required.</small>
                  }
                </div>
                }
            </div>
            }
            @if ((Type == 'Case' && CurrencyCase == '1') || (Type == 'Notice' && CurrencyCase == '1') ) {
            <div class="col-12 col-md-4">
              <label for="Currency" class="form-label"><a routerLink="{{ RouteGMCurrency }}"
                  target="_blank">{{captionCurrency}}</a> <span class="text-danger">*</span> </label>
              <ng-select [items]="Currency" bindLabel="MainDescr" bindValue="hdID" formControlName="Currency"
                [clearable]="false" placeholder="Select {{captionCurrency}}">
              </ng-select>
              @if (f.Currency.touched && f.Currency.invalid) {
                <div class="text-danger">
                  @if (f.Currency.errors?.['required']) {
                    <small>{{captionCurrency}} is required.</small>
                  }
                </div>
                }
            </div>
            }
            @if ((Type == 'Case' && RecoveryAmountCase == '1') || (Type == 'Notice' && RecoveryAmountNotice == '1') ) {
            <div class="col-12 col-md-4">
              <label for="RecoveryAmount" class="form-label">{{captionRecoveryAmount}} <span class="text-danger">*</span> </label>
              <input type="text" class="form-control" (keyup)="onChangeRecoveryAmount($event.target.value)"
                formControlName="RecoveryAmount" placeholder="Enter {{captionRecoveryAmount}}" />
              @if (f.RecoveryAmount.touched && f.RecoveryAmount.invalid) {
                <div class="text-danger">
                  @if (f.RecoveryAmount.errors?.['required']) {
                    <small>{{captionRecoveryAmount}} is required.</small>
                  }
                </div>
                }
            </div>
            }
            @if ((Type == 'Case' && NegotiateAmountCase == '1') || (Type == 'Notice' && NegotiateAmountNotice == '1')) {
            <div class="col-12 col-md-4">
              <label for="NegotiateAmount" class="form-label">{{ captionNegotiateAmount}} <span class="text-danger">*</span> </label>
              <input type="text" class="form-control" (keyup)="onChangeNegotiateAmount($event.target.value)"
                formControlName="NegotiationAmount" placeholder="Enter {{ captionNegotiateAmount }}" />
              @if (f.NegotiateAmount.touched && f.NegotiateAmount.invalid) {
                <div class="text-danger">
                  @if (f.NegotiateAmount.errors?.['required']) {
                    <small>{{ captionNegotiateAmount }} is required.</small>
                  }
                </div>
                }
            </div>
            }
            @if ((Type == 'Case' && BalanceAmountCase == '1') || (Type == "Notice" && BalanceAmountNotice == '1')) {
            <div class="col-12 col-md-4">
              <label for="BalanceAmount" class="form-label">{{captionBalanceAmount}} <span class="text-danger">*</span> </label>
              <input type="text" class="form-control" formControlName="BalanceAmount"
                placeholder="Enter {{captionBalanceAmount}}" />
              @if (f.BalanceAmount.touched && f.BalanceAmount.invalid) {
                <div class="text-danger">
                  @if (f.BalanceAmount.errors?.['required']) {
                    <small>{{captionBalanceAmount}} is required.</small>
                  }
                </div>
                }
            </div>
            }
            @if ((Type == 'Case' && FIRDateCase == '1') || (Type == 'Notice' && FIRDateNotice == '1')) {
            <div class="col-12 col-md-4">
              <label for="FIRDate" class="form-label"> {{ captionFIRDate}} <span class="text-danger">*</span> </label>
              <mat-form-field class="fullwidth" appearance="outline">
                <input matInput [min]="minDate" formControlName="FIRDate" [max]="maxDate" [matDatepicker]="picker5"
                  placeholder="Choose a date" class="form-control" />
                <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                <mat-datepicker #picker5></mat-datepicker>
              </mat-form-field>
              @if (f.FIRDate.touched && f.FIRDate.invalid) {
                <mat-error>
                  @if (f.FIRDate.errors?.['required']) {
                    <small>{{ captionFIRDate }} is required.</small>
                  }
                </mat-error>
                }
            </div>
            }
            @if((Type == 'Case' && AgencyCase == '1') || (Type == 'Notice' && AgencyNotice == '1')) {
            <div class="col-12 col-md-4">
              <label for="Agency" class="form-label"> <a routerLink="{{ RouteGMAgency }}" target="_blank">{{captionAgency}} <span class="text-danger">*</span> </a>
              </label>
              <ng-select [items]="Agency" bindLabel="MainDescr" bindValue="hdID" formControlName="Agency"
                [clearable]="false" placeholder="Select {{captionAgency}}">
              </ng-select>
              @if (f.Agency.touched && f.Agency.invalid) {
                <div class="text-danger">
                  @if (f.Agency.errors?.['required']) {
                    <small>{{captionAgency}} is required.</small>
                  }
                </div>
                }
            </div>
            }
            @if ((Type == 'Case' && PoliceStationCase == '1') || (Type == 'Notice' && PoliceStationNotice == '1')) {
            <div class="col-12 col-md-4">
              <label for="PoliceStation" class="form-label"> {{PoliceStation}} <span class="text-danger">*</span> </label>
              <ng-select [items]="PoliceStation" bindLabel="MainDescr" bindValue="hdID" formControlName="PoliceStation"
                [clearable]="false" placeholder="Select {{PoliceStation}}">
              </ng-select>
              @if (f.PoliceStation.touched && f.PoliceStation.invalid) {
                <div class="text-danger">
                  @if (f.PoliceStation.errors?.['required']) {
                    <small>{{PoliceStation}} is required.</small>
                  }
                </div>
                }
            </div>
            }
            @if (str1 != 'Project') {
            <div class="col-12 col-md-4">
              <label for="InvestigatingOfficer" class="form-label">{{InvestigatingOfficer}} <span class="text-danger">*</span> </label>
              <input class="form-control" formControlName="InvestigatingOfficer"
                placeholder="Enter {{ InvestigatingOfficer }}" name="OfficerName" type="text" value="" />
              @if (f.InvestigatingOfficer.touched && f.InvestigatingOfficer.invalid) {
                <div class="text-danger">
                  @if (f.InvestigatingOfficer.errors?.['required']) {
                    <small>{{InvestigatingOfficer}} is required.</small>
                  }
                </div>
                }
            </div>
            }
            @if((Type == 'Case' && InsuranceAmountCase == '1') || (Type == 'Notice' && InsuranceAmountNotice == '1')) {
            <div class="col-12 col-md-4">
              <label for="InsuranceAmount" class="form-label">Insurance Amount <span class="text-danger">*</span> </label>
              <input type="text" class="form-control" formControlName="InsuranceAmount"
                placeholder="Enter Insurance Amount" />
              @if (f.InsuranceAmount.touched && f.InsuranceAmount.invalid) {
                <div class="text-danger">
                  @if (f.InsuranceAmount.errors?.['required']) {
                    <small>Insurance Amount is required.</small>
                  }
                </div>
                }
            </div>
            }
            @if (CommunityDisplayRegionBranch == '1') {
            <div class="col-12 col-md-4">
              <label for="CommunityRegion" class="form-label"> <a routerLink="{{ RouteGMRegion }}"
                  target="_blank">{{captionRegion}}</a> <span class="text-danger">*</span> </label>
              <ng-select [items]="Region" bindLabel="MainDescr" bindValue="hdID" formControlName="Region"
                [clearable]="false" placeholder="Select {{captionRegion}}" (change)="onRegionSelect($event)" >
              </ng-select>
            @if (f.Region.touched && f.Region.invalid) {
                <div class="text-danger">
                  @if (f.Region.errors?.['required']) {
                    <small>{{captionRegion}} is required.</small>
                  }
                </div>
              }
            </div>
            <div class="col-12 col-md-4">
              <label for="CommunityBranch" class="form-label"> <a routerLink="{{ RouteGMBranch }}"
                  target="_blank">Branch</a> <span class="text-danger">*</span> </label>
              <ng-select [items]="Branch" bindLabel="MainDescr" bindValue="hdID" formControlName="Branch"
                [clearable]="false" placeholder="Select {{captionBranch}}">
              </ng-select>
            @if (f.Branch.touched && f.Branch.invalid) {
                <div class="text-danger">
                  @if (f.Branch.errors?.['required']) {
                    <small>{{captionBranch}} is required.</small>
                  }
                </div>
              }
            </div>
            }
          </div>
        </div>
      </div>
      @if (!HideButtonSubmit && ShowHideSharingOption != '1') {
      @if ( (Type === 'Case' && RightsID.includes('202032001')) ||
      (Type === 'Case' && RightsID.includes('202032021')) ||
      (Type === 'Notice' && RightsID.includes('202030001')) ||
      (Type === 'Notice' && RightsID.includes('202030021'))) {
      <div class="d-flex align-items-center justify-content-center mt-3">
        <button class="btn btn-primary submit-btn" [type]="DisplaySaveNoticeButton" >
          {{ HeaderButtonCaption }}
        </button>
      </div>
      }
      }
    </form>

    <!-- @if (false) {
    <form #AddNotice="ngForm" [formGroup]="addFormNotice" (ngSubmit)="onHeaderSubmit(AddNotice.value); clicked = true">
      <div class="">
        <table width="100%" class="LMtable_lite entry ">
          <tr>
            <td width="10%">{{ Type }} <span style="color: red">*</span></td>
            <td width="23%">
              <div class="col-sm-11">
                <ng-select [items]="[{id: '1', name: Sent}, {id: '0', name: Received}]" bindLabel="name" bindValue="id"
                  formControlName="Notice" [clearable]="false" placeholder="Select Type">
                </ng-select>
              </div>
            </td>
            <td width="10%">
              <a routerLink="{{ RouteGMSection }}" target="_blank">Section</a>
            </td>
            <td width="24%">
              <div class="col-sm-11">
                <ng-select [items]="SectionList" [clearable]="false" [multiple]="true" formControlName="Section"
                  bindLabel="MainDescr" [selectableGroup]="true" [closeOnSelect]="true" bindValue="hdID"
                  [(ngModel)]="selectedSections">
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    {{ item.MainDescr }}
                  </ng-template>
                </ng-select>
              </div>
            </td>
            <td>{{ this.FIRNo }}</td>
            <td>
              <div class="col-sm-11">
                <input class="form-control" formControlName="FIRNo" placeholder="Enter {{ this.FIRNo }}" name="FIRNo"
                  type="text" value="" />
              </div>
            </td>
          </tr>
          <tr>
            <td>e-Court Type</td>
            <td>
              <div class="col-sm-11">
                <ng-select [items]="EcourtTypeId" bindLabel="MainDescr" bindValue="hdID" formControlName="EcourtTypeId"
                  (change)="onCourtSelect($event)" [clearable]="false" placeholder="Not Selected">
                </ng-select>
              </div>
            </td>
            <td>{{ CourtName }}</td>
            <td>
              <div class="col-sm-11">
                <input class="form-control" formControlName="EcourtNo" placeholder="Enter e-Court Name" type="text"
                  value="" />
              </div>
            </td>
            <td>Case Code</td>
            <td>
              <div class="col-sm-11">
                <input type="text" formControlName="OriginalrefNo" class="form-control" placeholder="Case Code" />
              </div>
            </td>
          </tr>
          <tr>
            <td>{{ this.RefNo }} <span style="color: red">*</span></td>
            <td>
              <div class="col-sm-11">
                <input type="text" formControlName="RefNo" class="form-control" />
              </div>
            </td>
            <td>{{ this.CaptionShortName }}</td>
            <td>
              <div class="col-sm-11">
                <input class="form-control" formControlName="ShortName" placeholder="Enter {{ this.CaptionShortName }}"
                  name="shortname" type="text" value="" />
              </div>
            </td>
            <td>
              <a routerLink="{{ RouteUserMaster }}" target="_blank">Manager</a>
            </td>
            <td>
              <div class="col-sm-11">
                <ng-select [items]="Manager" bindLabel="name" bindValue="id1" formControlName="Manager"
                  [clearable]="false" placeholder="Not Selected">
                </ng-select>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <a routerLink="{{ RouteGMCategory }}" target="_blank">Category</a>/<a
                routerLink="{{ RouteGMSubCategory }}" target="_blank">SubCategory</a>
            </td>
            <td>
              <div>
                <div class="col-sm-6">
                  <ng-select [items]="Category" bindLabel="MainDescr" bindValue="hdID" formControlName="Category"
                    [clearable]="false" (change)="onCategorySelect($event)" placeholder="Not Selected">
                  </ng-select>
                </div>
                <div class="col-sm-5">
                  <ng-select [items]="SubCategory" bindLabel="MainDescr" bindValue="hdID" formControlName="SubCategory"
                    [clearable]="false" placeholder="Not Selected">
                  </ng-select>
                </div>
              </div>
            </td>

            <div *ngIf="str1 === 'Project'; then content; else other_content">
              here is ignored
            </div>
            <ng-template #content>
              <td>
                <a routerLink="{{ RouteGMDepartment }}" target="_blank">Project</a>
              </td>
              <td>
                <div class="col-sm-11">
                  <ng-select [items]="Department" bindLabel="MainDescr" bindValue="hdID" formControlName="Department"
                    [clearable]="false" placeholder="Not Selected">
                    <ng-option [value]="'0'">[Not Selected]</ng-option>
                  </ng-select>
                </div>
              </td>
            </ng-template>

            <ng-template #other_content>
              <td>
                <a routerLink="{{ RouteCompany }}" target="_blank">Company</a>/<a routerLink="{{ RouteGMDepartment }}"
                  target="_blank">Department</a>
              </td>
              <td>
                <div class="col-sm-6">
                  <ng-select [items]="Company" bindLabel="name" bindValue="id" formControlName="Company"
                    [clearable]="false" placeholder="Not Selected">
                  </ng-select>
                </div>
                <div class="col-sm-5">
                  <ng-select [items]="Department" bindLabel="MainDescr" bindValue="hdID" formControlName="Department"
                    [clearable]="false" placeholder="Not Selected">
                  </ng-select>
                </div>
            </ng-template>

            <td>
              <a routerLink="{{ RouteUserMaster }}" target="_blank">Leader</a>
            </td>
            <td>
              <div class="col-sm-11">
                <ng-select [items]="Department" bindLabel="MainDescr" bindValue="hdID" formControlName="Department"
                  [clearable]="false" placeholder="Not Selected">
                  <ng-option [value]="'0'">[Not Selected]</ng-option>
                </ng-select>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              Date of filling of {{ Type }}<span style="color: red">*</span>
            </td>
            <td>
              <div class="col-sm-11">
                <mat-form-field class="fullwidth">
                  <input matInput [min]="minDate" formControlName="DateofNotice" [max]="maxDate"
                    [matDatepicker]="picker" placeholder="Choose a date" class="" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
            </td>
            <td>
              <a routerLink="{{ RouteGMState }}" target="_blank">State</a>
            </td>
            <td>
              <div class="col-sm-11">
                <ng-select [items]="State" bindLabel="MainDescr" bindValue="hdID" formControlName="State"
                  [clearable]="false" (change)="onStateSelect($event)" placeholder="Not Selected">
                </ng-select>
              </div>
            </td>
            <td *ngIf="this.TypeHeader == 'Notice'">
              <a routerLink="{{ RouteGMNoticeStatus }}" target="_blank">Status</a>
            </td>
            <td *ngIf="this.TypeHeader == 'Case'">
              <a routerLink="{{ RouteGMCaseStatus }}" target="_blank">Status</a>
            </td>
            <td>
              <div class="col-sm-11">
                <ng-select [items]="Stages" bindLabel="MainDescr" bindValue="hdID" formControlName="Stages"
                  [clearable]="false" placeholder="Not Selected">
                  <ng-option [value]="'0'">[Not Selected]</ng-option>
                </ng-select>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              {{ this.CaptionDateofReceiving }}<span style="color: red">*</span>
            </td>
            <td>
              <div class="col-sm-11">
                <mat-form-field class="fullwidth">
                  <input matInput [min]="minDate" formControlName="DateofReceiving" [max]="maxDate"
                    [matDatepicker]="picker1" placeholder="Choose a date" class="" />
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
              </div>
            </td>
            <td><a routerLink="{{ RouteGMCity }}" target="_blank">City</a></td>
            <td>
              <div class="col-sm-11">
                <ng-select [items]="City" bindLabel="MainDescr" bindValue="hdID" formControlName="City"
                  [clearable]="false" (change)="onCitySelect($event)" placeholder="Not Selected">
                </ng-select>
              </div>
            </td>
            <td>Seriousness</td>
            <td>
              <div class="col-sm-11">
                <ng-select [items]="Seriousness" bindLabel="SubDescr" bindValue="SubID" formControlName="Seriousness"
                  [clearable]="false" placeholder="Not Selected">
                  <ng-option [value]="'0'">[Not Selected]</ng-option>
                </ng-select>
              </div>
            </td>
          </tr>
          <tr>
            <td>Target Date<span style="color: red">*</span></td>
            <td>
              <div class="col-sm-11">
                <mat-form-field class="fullwidth">
                  <input matInput [min]="minDate" formControlName="TargetDate" [max]="maxDate" [matDatepicker]="picker2"
                    placeholder="Choose a date" />
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
              </div>
            </td>
            <td>
              <a routerLink="{{ RouteGMJurisdiction }}" target="_blank">{{
                this.CaptionJurisdiction
                }}</a>
            </td>
            <div class="col-sm-11">
              <ng-select [items]="Jurisdiction" bindLabel="MainDescr" bindValue="hdID" formControlName="Jurisdiction"
                [clearable]="false" placeholder="Not Selected">
                <ng-option [value]="'0'">[Not Selected]</ng-option>
              </ng-select>
            </div>
            <td>{{ this.CaptionExposurAmount }}</td>
            <td>
              <div class="col-sm-11">
                <input class="form-control" formControlName="ExposureAmmount"
                  (keyup)="onChangeExposureAmount($event.target.value)" placeholder="Enter Exposure Amount" step="0.01"
                  name="exposureamount" type="number" value="" />
              </div>
            </td>
          </tr>
          <tr *ngIf="this.TypeHeader == 'Case'">
            <div *ngIf="str1 != 'Project'; then content4">here is ignored</div>
            <ng-template #content4>
              <td *ngIf="
                          (this.Type == 'Case' && this.BenchCase == '1') ||
                          (this.Type == 'Notice' && this.BenchNotice == '1')
                        ">
                Bench No
              </td>
              <td *ngIf="
                          (this.Type == 'Case' && this.BenchCase == '1') ||
                          (this.Type == 'Notice' && this.BenchNotice == '1')
                        ">
                <div class="col-sm-11">
                  <input class="form-control" formControlName="BenchNo" placeholder="Enter Bench No" name="BanchNo"
                    type="text" value="" />
                </div>
              </td>
            </ng-template>

            <td>{{ this.JudgeName }}</td>
            <td>
              <div class="col-sm-11">
                <input class="form-control" formControlName="JudgeName" placeholder="Enter {{ this.JudgeName }}"
                  name="JudgeName" type="text" value="" />
              </div>
            </td>
            <td>
              <h6>
                <a routerLink="/addorgcontact/1/0" target="_blank">Lawyer Name</a>
              </h6>
            </td>
            <td>
              <div class="col-sm-11">
                <ng-select [items]="Lawyer" bindLabel="Name" bindValue="ContactID" formControlName="Lawyer"
                  [clearable]="false" placeholder="Not Selected">
                  <ng-option [value]="'0'">[Not Selected]</ng-option>
                </ng-select>
              </div>
            </td>
            <td *ngIf="str1 == 'Project'">{{ this.InvestigatingOfficer }}</td>
            <td *ngIf="str1 == 'Project'">
              <div class="col-sm-11">
                <input class="form-control" formControlName="InvestigatingOfficer"
                  placeholder="Enter {{ this.InvestigatingOfficer }}" name="OfficerName" type="text" value="" />
              </div>
            </td>
          </tr>
          <tr>
            <td>{{ this.DueDate }}<span style="color: red">*</span></td>
            <td>
              <div class="col-sm-11">
                <mat-form-field class="fullwidth">
                  <input matInput [min]="minDate" formControlName="DueDate" [max]="maxDate" [matDatepicker]="picker3"
                    placeholder="Choose a date" />
                  <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                  <mat-datepicker #picker3></mat-datepicker>
                </mat-form-field>
              </div>
            </td>
            <td>{{ this.LastDate }}<span style="color: red">*</span></td>
            <td>
              <div class="col-sm-11">
                <mat-form-field class="fullwidth">
                  <input matInput [min]="minDate" formControlName="LastDate" [max]="maxDate" [matDatepicker]="picker4"
                    placeholder="Please change the date" class="" />
                  <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                  <mat-datepicker #picker4></mat-datepicker>
                </mat-form-field>
              </div>
            </td>

            <td *ngIf="
                        (this.Type == 'Case' && this.CourtNumberCase == '1') ||
                        (this.Type == 'Notice' && this.CourtNumberNotice == '1')
                      ">
              Court No.
            </td>
            <td *ngIf="
                        (this.Type == 'Case' && this.CourtNumberCase == '1') ||
                        (this.Type == 'Notice' && this.CourtNumberNotice == '1')
                      ">
              <div class="col-sm-11">
                <input class="form-control" formControlName="CourtName" placeholder="Enter Court Name" name="Courtname"
                  type="text" value="" />
              </div>
            </td>
          </tr>

          <tr>
            <td *ngIf="
                        (this.Type == 'Case' && this.CurrencyCase == '1') ||
                        (this.Type == 'Notice' && this.CurrencyNotice == '1')
                      ">
              <a routerLink="{{ RouteGMCurrency }}" target="_blank">Currency</a>
            </td>
            <td *ngIf="
                        (this.Type == 'Case' && this.CurrencyCase == '1') ||
                        (this.Type == 'Notice' && this.CurrencyNotice == '1')
                      ">
              <div class="col-sm-11">
                <ng-select [items]="Currency" bindLabel="MainDescr" bindValue="hdID" formControlName="Currency"
                  [clearable]="false" placeholder="Not Selected">
                </ng-select>
              </div>
            </td>
            <td *ngIf="
                        (this.Type == 'Case' && this.RecoveryAmountCase == '1') ||
                        (this.Type == 'Notice' && this.RecoveryAmountNotice == '1')
                      ">
              Recovery Amount
            </td>
            <td *ngIf="
                        (this.Type == 'Case' && this.RecoveryAmountCase == '1') ||
                        (this.Type == 'Notice' && this.RecoveryAmountNotice == '1')
                      ">
              <div class="col-sm-11">
                <input class="form-control" formControlName="RecoveryAmount"
                  (keyup)="onChangeRecoveryAmount($event.target.value)" placeholder="Enter Recovery Amount"
                  name="Recoveryamount" type="number" value="" />
              </div>
            </td>
            <td *ngIf="
                        (this.Type == 'Case' && this.NegotiateAmountCase == '1') ||
                        (this.Type == 'Notice' && this.NegotiateAmountNotice == '1')
                      ">
              Negotiation Amount
            </td>
            <td *ngIf="
                        (this.Type == 'Case' && this.NegotiateAmountCase == '1') ||
                        (this.Type == 'Notice' && this.NegotiateAmountNotice == '1')
                      ">
              <div class="col-sm-11">
                <input class="form-control" formControlName="NegotiationAmount"
                  (keyup)="onChangeNegotiateAmount($event.target.value)" placeholder="Enter Nagotiation Amount"
                  name="negotiationamount" type="number" value="" />
              </div>
            </td>
          </tr>

          <tr>
            <td *ngIf="
                        (this.Type == 'Case' && this.BalanceAmountCase == '1') ||
                        (this.Type == 'Notice' && this.BalanceAmountNotice == '1')
                      ">
              Balance Amount
            </td>
            <td *ngIf="
                        (this.Type == 'Case' && this.BalanceAmountCase == '1') ||
                        (this.Type == 'Notice' && this.BalanceAmountNotice == '1')
                      ">
              <div class="col-sm-11">
                <input class="form-control" formControlName="BalanceAmount" placeholder="Enter Balance Amount"
                  name="balanceamount" type="number" value="" />
              </div>
            </td>
            <td *ngIf="
                        (this.Type == 'Case' && this.FIRDateCase == '1') ||
                        (this.Type == 'Notice' && this.FIRDateNotice == '1')
                      ">
              FIR Date
            </td>
            <td *ngIf="
                        (this.Type == 'Case' && this.FIRDateCase == '1') ||
                        (this.Type == 'Notice' && this.FIRDateNotice == '1')
                      ">
              <div class="col-sm-11">
                <mat-form-field class="fullwidth">
                  <input matInput [min]="minDate" formControlName="FIRDate" [max]="maxDate" [matDatepicker]="picker5"
                    placeholder="Choose a FIR Date" />
                  <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                  <mat-datepicker #picker5></mat-datepicker>
                </mat-form-field>
              </div>
            </td>
            <td *ngIf="
                        (this.Type == 'Case' && this.AgencyCase == '1') ||
                        (this.Type == 'Notice' && this.AgencyNotice == '1')
                      " width="10%">
              <a routerLink="{{ RouteGMAgency }}" target="_blank">Agency</a>
            </td>
            <td *ngIf="
                        (this.Type == 'Case' && this.AgencyCase == '1') ||
                        (this.Type == 'Notice' && this.AgencyNotice == '1')
                      " width="23%">
              <div class="col-sm-11">
                <ng-select [items]="Agency" bindLabel="MainDescr" bindValue="hdID" formControlName="Agency"
                  [clearable]="false" placeholder="Not Selected">
                </ng-select>
              </div>
            </td>
          </tr>
          <tr>
            <td *ngIf="
                        (this.Type == 'Case' && this.PoliceStationCase == '1') ||
                        (this.Type == 'Notice' && this.PoliceStationNotice == '1')
                      ">
              {{ this.PoliceStation }}
            </td>
            <td *ngIf="
                        (this.Type == 'Case' && this.PoliceStationCase == '1') ||
                        (this.Type == 'Notice' && this.PoliceStationNotice == '1')
                      ">
              <div class="col-sm-11">
                <input class="form-control" formControlName="PoliceStation" placeholder="Enter {{ this.PoliceStation }}"
                  name="Police Station" type="text" value="" />
              </div>
            </td>

            <td *ngIf="str1 != 'Project'">{{ this.InvestigatingOfficer }}</td>
            <td *ngIf="str1 != 'Project'">
              <div class="col-sm-11">
                <input class="form-control" formControlName="InvestigatingOfficer"
                  placeholder="Enter {{ this.InvestigatingOfficer }}" name="OfficerName" type="text" value="" />
              </div>
            </td>

            <td *ngIf="
                        (this.Type == 'Case' && this.InsuranceAmountCase == '1') ||
                        (this.Type == 'Notice' && this.InsuranceAmountNotice == '1')
                      ">
              <div *ngIf="this.TypeHeader == 'Case'">Insurance Amount</div>
            </td>
            <td *ngIf="
                        (this.Type == 'Case' && this.InsuranceAmountCase == '1') ||
                        (this.Type == 'Notice' && this.InsuranceAmountNotice == '1')
                      ">
              <div *ngIf="this.TypeHeader == 'Case'" class="col-sm-11">
                <input class="form-control" formControlName="InsuranceAmount" placeholder="Enter Insurance Amount"
                  step="0.01" name="exposureamount" type="number" value="" />
              </div>
            </td>
          </tr>

          <tr *ngIf="this.CommunityDisplayRegionBranch == '1'">
            <td><a href="{{ RouteGMRegion }}" target="_blank">Region</a></td>
            <td>
              <div class="col-sm-11">
                <ng-select [items]="Region" bindLabel="MainDescr" bindValue="hdID" formControlName="Region"
                  (change)="onRegionSelect($event)" [clearable]="false" placeholder="Not Selected">
                  <ng-option [value]="'0'">[Not Selected]</ng-option>
                </ng-select>
              </div>
            </td>
            <td><a href="{{ RouteGMBranch }}" target="_blank">Branch</a></td>
            <td>
              <div class="col-sm-11">
                <ng-select [items]="Branch" bindLabel="MainDescr" bindValue="hdID" formControlName="Branch"
                  [clearable]="false" placeholder="Not Selected">
                  <ng-option [value]="'0'">[Not Selected]</ng-option>
                </ng-select>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="col-sm-12">&nbsp;</div>
      <div class="col-sm-12" [hidden]="HideButtonSubmit" *ngIf="this.ShowHideSharingOption != '1'">
        <div class="col-sm-5"></div>
        <div [hidden]="HideContent" *ngIf="
                    (this.Type == 'Case' && this.RightsID.includes('202032001')) ||
                      (this.Type == 'Case' && this.RightsID.includes('202032021')) ||
                      (this.Type == 'Notice' && this.RightsID.includes('202030001')) ||
                      (this.Type == 'Notice' && this.RightsID.includes('202030021'));
                    then HeaderButtonLink;
                    else HeaderButton
                  "></div>
        <ng-template #HeaderButtonLink>
          <input class="btn btn-primary col-sm-2" [type]="DisplaySaveNoticeButton" value="{{ HeaderButtonCaption }}" />
        </ng-template>
        <ng-template #HeaderButton>
          <div class="col-sm-2">&nbsp;</div>
        </ng-template>
        <div class="col-sm-5"></div>
      </div>
      <div col-sm-12>&nbsp;</div>
    </form>
    } -->
    @if(!DisplayExistNotice){
    <div class="row my-4">
      <div class="col-md-6">
        <form [formGroup]="addFormFillingParty" (ngSubmit)="onFillingPartySubmit(addFormFillingParty.value)">
          <div class="card">
            <div class="card-header">
              <a routerLink="/addorgcontact/0/0" target="_blank">{{captionFilingParty }}</a>
            </div>
            <div class="card-body">
              <div class="d-flex mb-3">
                <ng-select [items]="filteredFillingParty" [clearable]="false" [multiple]="false" class="w-100"
                  formControlName="fillingPartyName" bindLabel="Name" [selectableGroup]="true" [closeOnSelect]="true"
                  placeholder="Select {{captionFilingParty}}" bindValue="ID">
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    {{ item.Name }}({{ item.State }},{{
                    item.City
                    }})
                  </ng-template>
                </ng-select>
                <button [hidden]="HideContent" class="btn btn-primary ms-3"> <i class="fa fa-plus"></i> Add</button>
              </div>
              <div class="card">
                <table class="custom-table">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    @if (FetchExistingFillingParty?.length > 0) {
                      @for (feFD of FetchExistingFillingParty; track $index ;let i = $index){
                      <tr>
                        <td>
                          {{i+1}}
                        </td>
                        <td>
                          @if(RightsID.includes('202034000') || RightsID.includes('202034001') ||
                          RightsID.includes('202034021')){
                          <a routerLink="/addorgcontact/{{feFD.ID}}/0" target="_blank">
                            {{feFD.Name}}
                          </a>
                          }
                          @else {
                          <a routerLink="/module/0" target="_blank">
                            {{feFD.Name}}
                          </a>
                          }
                          {{feFD.State}}({{feFD.City}})&({{feFD.Mobile}})
                        </td>
                        <td>
                          @if( Type == 'Notice' && RightsID.includes('202030021') || Type == 'Case' &&
                          RightsID.includes('202032021')){
                          <button class="icon-btn icon-btn-danger" (click)="deleteNoticeContact(feFD.ID)" title="Delete">
                            <i class="fa fa-trash"></i>
                          </button>
                          }@else{
                          <button class="icon-btn icon-btn-danger" routerLink="/module/0" title="Delete" target="_blank">
                            <i class="fa fa-trash"></i>
                          </button>
                          }
                        </td>
                      </tr>
                      }
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-md-6">
        <form [formGroup]="addFormOppositeParty" (ngSubmit)="onOppositePartySubmit(addFormOppositeParty.value)">
          <div class="card">
            <div class="card-header">
              <a routerLink="/addorgcontact/0/0" target="_blank">{{captionOppositeParty }}</a>
            </div>
            <div class="card-body">
              <div class="d-flex mb-3">
                <ng-select [items]="filteredOppositeParty" [clearable]="false" [multiple]="false" class="w-100"
                  formControlName="oppositePartyName" bindLabel="Name" [selectableGroup]="true" [closeOnSelect]="true"
                  placeholder="Select {{captionOppositeParty}}" bindValue="ID">
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    {{ item.Name }}({{ item.State }},{{
                    item.City
                    }})
                  </ng-template>
                </ng-select>
                <button [hidden]="HideContent"  class="btn btn-primary ms-3"> <i class="fa fa-plus"></i> Add</button>
              </div>
              <div class="card">
                <table class="custom-table">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    @if (FetchExistingOppositeParty?.length > 0) {
                      @for (feFD of FetchExistingOppositeParty; track $index ;let i = $index){
                      <tr>
                        <td>
                          {{i+1}}
                        </td>
                        <td>
                          @if(RightsID.includes('202034000') || RightsID.includes('202034001') ||
                          RightsID.includes('202034021')){
                          <a routerLink="/addorgcontact/{{feFD.ID}}/0" target="_blank">
                            {{feFD.Name}}
                          </a>
                          }
                          @else {
                          <a routerLink="/module/0" target="_blank">
                            {{feFD.Name}}
                          </a>
                          }
                          {{feFD.State}}({{feFD.City}})&({{feFD.Mobile}})
                        </td>
                        <td>
                          @if( Type == 'Notice' && RightsID.includes('202030021') || Type == 'Case' &&
                          RightsID.includes('202032021')){
                          <button class="icon-btn icon-btn-danger" (click)="deleteNoticeContact(feFD.ID)" title="Delete">
                            <i class="fa fa-trash"></i>
                          </button>
                          }@else{
                          <a routerLink="/module/0" target="_blank" title="Delete" class="icon-btn icon-btn-danger">
                            <i class="fa fa-trash"></i>
                          </a>
                          }
                        </td>
                      </tr>
                      }
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="card border-0 rounded-4 my-3" [hidden]="HideButtonSubmit">
      <div class="card-body p-3 d-flex justify-content-between">
        @if (RightsID.includes('202046001') || RightsID.includes('202046021')) {
        <button class="status-action-btn add-to-followup"
          (click)="OpenModal('afuc', '0', 'FetchNoticeHistory', 'Add Follow UP')" data-toggle="modal"
          data-target="#ModalPopUP">
          <i class="fa fa-comments"></i> {{ AddFollowupLink }}
        </button>
        } @else {
        <a routerLink="/module/0" class="btn btn-outline-secondary btn-block action-btn">
          <i class="fa fa-comments"></i> {{ AddFollowupLink }}
        </a>
        }
        @if (RightsID.includes('202024001') || RightsID.includes('202024021')) {
        <button class="status-action-btn add-to-diary"
          (click)="OpenModal('ndc', '0', 'FetchNoticeHistory', 'Add Notice Diary')" data-toggle="modal"
          data-target="#ModalPopUP">
          <i class="fa-solid fa-book"></i> Add To Diary
        </button>
        } @else {
        <a routerLink="/module/0" class="btn btn-outline-secondary btn-block action-btn">
          <i class="fa-solid fa-book"></i> Add To Diary
        </a>
        }
        @if (Type == 'Case') {
        <button class="status-action-btn print-case" (click)="getPDF()">
          <i class="fa-solid fa-print"></i> Print Case
        </button>
        }

        @if(RoleID != '4') {
        @if (Type == 'Notice') {
        <button class="status-action-btn print-case" (click)="getPDF()">
          <i class="fa-solid fa-print"></i> Print Notice
        </button>
        <button *ngIf="RightsID.includes('202032001') || RightsID.includes('202032021'); else ConvertCase"
          class="status-action-btn convert-to-case" (click)="ConvertNoticeinCase()">
          <i class="fa-solid fa-folder-open"></i> Convert to Case
        </button>
        <ng-template #ConvertCase>
          <a routerLink="/module/0" class="btn btn-outline-secondary btn-block action-btn">
            <i class="fa-solid fa-folder-open"></i> Convert to Case
          </a>
        </ng-template>
        }
        @if ((Type == 'Notice' || Type == 'Case') && (RightsID.includes('202026001') || RightsID.includes('202026021')))
        {
        <button class="status-action-btn add-expense" data-toggle="modal"
          (click)="OpenModal('expense','0','FetchExpenseDetail','Add Expense Detail')" data-target="#ModalPopUP">
          <i class="fa-solid fa-receipt"></i> Add Expense
        </button>
        }
        }

        @if ((ShowHideSharingOption != 1 ) && (Type == 'Notice' || Type == 'Case')) {
        <button class="status-action-btn evolution"
          (click)="OpenModal('evalentry', (Type=='Notice')?'2':'0', 'FetchDescisionHistory', 'Evaluation Form')"
          data-toggle="modal" data-target="#ModalPopUP">
          <i class="fa-solid fa-circle-check"></i> Evaluation
        </button>
        }
        @if (Type == 'Case' && ShowHideSharingOption != 1) {
        <button class="status-action-btn evolution" [routerLink]="['/casetransfer/case', id]">
          <i class="fa-solid fa-exchange"></i> Case Transfer
        </button>
        }

        @if (ShowHideSharingOption != '1') {
        <button class="status-action-btn close-notice" (click)="CloseRecord()">
          <i class="fa-solid fa-times-circle"></i> Close {{ Type }}
        </button>
        }

        @if (ShowHideSharingOption != '1') {
        <button class="status-action-btn final-gavel" (click)="FinalVerdict()">
          <i class="fa-solid fa-gavel"></i> Final Verdict
        </button>
        }

        @if (Type == 'Case' && ShowHideSharingOption != '1') {
        <button class="status-action-btn sharing" data-toggle="modal"
          (click)="OpenModal('sharingoption', '0', '', 'Sharing Option')" data-target="#ModalPopUP">
          <i class="fa-solid fa-share"></i> Sharing
        </button>
        }
      </div>
    </div>
    }
    <div [hidden]="DisplayExistNotice">
      <!-- @if (false) {
      <table class="fullwidth LMtable" cellpadding="0">
        <tr>
          <td class="GreyHeading">
            <div class="">
              <h5>
                <a routerLink="/addorgcontact/0/0" target="_blank">Filling Party</a>
              </h5>
            </div>
          </td>
          <td class="GreyHeading">
            <div>
              <h5>
                <a routerLink="/addorgcontact/0/0" target="_blank">Opposite Party</a>
              </h5>
            </div>
          </td>
        </tr>
        <tr>
          <td width="50%">
            <div style="padding: 8px">
              <form #AddFilingParty="ngForm" [formGroup]="addFormFillingParty"
                (ngSubmit)="onFillingPartySubmit(AddFilingParty.value)">
                <div class="col-sm-1" style="padding: 10px">
                  <label>Select:</label>
                </div>
                <div class="col-sm-9">
                  <ng-select [items]="FilingOppoParty" [clearable]="false" [multiple]="false"
                    formControlName="fillingPartyName" bindLabel="Name" [selectableGroup]="true" [closeOnSelect]="true"
                    bindValue="ID">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                      {{ item.Name }}&nbsp;&nbsp;&nbsp;({{ item.State }},{{
                      item.City
                      }})&nbsp;&nbsp;&nbsp;({{ item.Mobile }})
                    </ng-template>
                  </ng-select>
                </div>
                <div [hidden]="HideContent" *ngIf="
                      (this.Type == 'Case' &&
                        this.RightsID.includes('202032001')) ||
                        (this.Type == 'Case' &&
                          this.RightsID.includes('202032021')) ||
                        (this.Type == 'Notice' &&
                          this.RightsID.includes('202030001')) ||
                        (this.Type == 'Notice' &&
                          this.RightsID.includes('202030021'));
                      then FillingButtonLink;
                      else FillingButton
                    "></div>
                <ng-template #FillingButtonLink>
                  <div class="col-sm-2" [hidden]="HideContent">
                    <input class="btn btn-primary btn-sm font-14" type="submit" value="Add" />
                  </div>
                </ng-template>
                <ng-template #FillingButton>
                  <div class="col-sm-2">&nbsp;</div>
                </ng-template>
              </form>
            </div>
          </td>
          <td width="50%">
            <div style="padding: 8px">
              <form #AddOppositeParty="ngForm" [formGroup]="addFormOppositeParty"
                (ngSubmit)="onOppositePartySubmit(AddOppositeParty.value)">
                <div class="col-sm-1" style="padding: 10px">
                  <label>Select:</label>
                </div>
                <div class="col-sm-9">
                  <ng-select [items]="FilingOppoParty" [clearable]="false" [multiple]="false"
                    formControlName="oppositePartyName" bindLabel="Name" [selectableGroup]="true" [closeOnSelect]="true"
                    bindValue="ID">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                      {{ item.Name }}&nbsp;&nbsp;&nbsp;({{ item.State }},{{
                      item.City
                      }})&nbsp;&nbsp;&nbsp;({{ item.Mobile }})
                    </ng-template>
                  </ng-select>
                </div>
                <div [hidden]="HideContent" *ngIf="
                      (this.Type == 'Case' &&
                        this.RightsID.includes('202032001')) ||
                        (this.Type == 'Case' &&
                          this.RightsID.includes('202032021')) ||
                        (this.Type == 'Notice' &&
                          this.RightsID.includes('202030001')) ||
                        (this.Type == 'Notice' &&
                          this.RightsID.includes('202030021'));
                      then OppositeButtonLink;
                      else OppositeButton
                    "></div>
                <ng-template #OppositeButtonLink>
                  <div class="col-sm-2" [hidden]="HideContent">
                    <input class="btn btn-primary btn-sm font-14" type="submit" value="Add" />
                  </div>
                </ng-template>
                <ng-template #OppositeButton>
                  <div class="col-sm-2">&nbsp;</div>
                </ng-template>
              </form>
            </div>
          </td>
        </tr>
        <tr>
          <td valign="top">
            <div class="col-sm-12 paddingless" *ngFor="let feFD of FetchExistingFillingParty; let i = index">
              <div class="col-sm-12">
                <b class="col-sm-5">
                  {{ i + 1 }} ) &nbsp; &nbsp;
                  <a *ngIf="
                        this.RightsID.includes('202034000') ||
                          this.RightsID.includes('202034001') ||
                          this.RightsID.includes('202034021');
                        then FillingPartyLink;
                        else FillingParty
                      "></a>
                  <ng-template #FillingPartyLink>
                    <a routerLink="/addorgcontact/{{ feFD.type }}/{{
                          feFD.ContactID
                        }}" target="_blank">{{ feFD.Name }}
                    </a>
                  </ng-template>
                  <ng-template #FillingParty>
                    <a routerLink="/module/0">{{ feFD.Name }} </a>
                  </ng-template>

                  &nbsp; &nbsp;
                </b>
                <span class="col-sm-6">{{ feFD.City }}&nbsp; &nbsp; {{ feFD.state }} &nbsp; &nbsp;{{
                  feFD.Mobile
                  }}</span>
                <a *ngIf="
                      (this.Type == 'Notice' &&
                        this.RightsID.includes('202030021')) ||
                        (this.Type == 'Case' &&
                          this.RightsID.includes('202032021'));
                      then DelFillingPartyLink;
                      else DelFillingParty
                    ">
                </a>
                <ng-template #DelFillingPartyLink>
                  <a title="Delete" (click)="deleteNoticeContact(feFD.ID)" class="col-sm-1">
                    <i class="fa fa-trash text-danger cursor-pointer" style="font-size: 20px;"></i>
                  </a>
                </ng-template>
                <ng-template #DelFillingParty>
                  <a routerLink="/module/0">
                    <i class="fa fa-trash text-danger cursor-pointer" style="font-size: 20px;"> </i>
                  </a>
                </ng-template>
              </div>
              <div class="col-sm-12">
                <hr />
              </div>
            </div>
          </td>
          <td valign="top">
            <div class="col-sm-12 paddingless" *ngFor="let feOP of FetchExistingOppositeParty; let i = index">
              <div class="col-sm-12">
                <b class="col-sm-5">{{ i + 1 }} ) &nbsp; &nbsp;
                  <a *ngIf="
                        this.RightsID.includes('202034000') ||
                          this.RightsID.includes('202034001') ||
                          this.RightsID.includes('202034021');
                        then OppositePartyLink;
                        else OppositeParty
                      "></a>
                  <ng-template #OppositePartyLink>
                    <a routerLink="/addorgcontact/{{ feOP.type }}/{{
                          feOP.ContactID
                        }}" target="_blank">{{ feOP.Name }}</a>
                  </ng-template>
                  <ng-template #OppositeParty>
                    <a routerLink="/module/0">{{ feOP.Name }}</a>
                  </ng-template>

                  &nbsp; &nbsp;
                </b>
                <span class="col-sm-6">{{ feOP.City }} &nbsp; &nbsp; {{ feOP.state }} &nbsp;
                  &nbsp;{{ feOP.Mobile }}</span>

                <a *ngIf="
                      (this.Type == 'Notice' &&
                        this.RightsID.includes('202030021')) ||
                        (this.Type == 'Case' &&
                          this.RightsID.includes('202032021'));
                      then DelOppositePartyLink;
                      else DelOppositeParty
                    ">
                </a>
                <ng-template #DelOppositePartyLink>
                  <a title="Delete" (click)="deleteNoticeContact(feOP.ID)" class="col-sm-1">
                    <i class="fa fa-trash text-danger cursor-pointer" style="font-size: 20px;"></i>
                  </a>
                </ng-template>
                <ng-template #DelOppositeParty>
                  <a routerLink="/module/0">
                    <i class="fa fa-trash text-danger cursor-pointer" style="font-size: 20px;"></i>
                  </a>
                </ng-template>
              </div>
              <div class="col-sm-12">
                <hr />
              </div>
            </div>
          </td>
        </tr>
      </table>

      <div class="col-sm-12">&nbsp;</div>
      <div class="col-sm-12" [hidden]="HideContent">&nbsp;</div>


      <div [hidden]="HideContent" class="action-container border rounded shadow-sm">

        <div class="col-auto" *ngIf="RightsID.includes('202046001') || RightsID.includes('202046021'); else FollowUp">
          <button class="btn btn-primary w-100 action-btn" data-toggle="modal"
            (click)="OpenModal('afuc', '0', 'FetchNoticeHistory', 'Add Follow UP')" data-target="#ModalPopUP">
            <i class="fa fa-commenting"></i> {{ AddFollowupLink }}
          </button>
        </div>
        <ng-template #FollowUp>
          <a routerLink="/module/0" class="btn btn-secondary w-100 action-btn">
            <i class="fa fa-commenting"></i> {{ AddFollowupLink }}
          </a>
        </ng-template>

        <div class="col-auto" *ngIf="RightsID.includes('202024001') || RightsID.includes('202024021'); else AddDiary">
          <button class="btn btn-info w-100 action-btn" data-toggle="modal"
            (click)="OpenModal('ndc', '0', 'FetchNoticeHistory', 'Add Notice Diary')" data-target="#ModalPopUP">
            <i class="fa fa-book"></i> Add To Diary
          </button>
        </div>
        <ng-template #AddDiary>
          <a routerLink="/module/0" class="btn btn-secondary w-100 action-btn">
            <i class="fa fa-book"></i> Add To Diary
          </a>
        </ng-template>

        <div class="col-auto" *ngIf="Type == 'Case'">
          <button class="btn btn-dark w-100 action-btn" (click)="getPDF()">
            <i class="fa fa-print"></i> Print Case
          </button>
        </div>

        <ng-container *ngIf="RoleID != '4'">
          <ng-container>

            <div class="col-auto" *ngIf="Type == 'Notice'">
              <button class="btn btn-dark w-100 action-btn" (click)="getPDF()">
                <i class="fa fa-print"></i> Print Notice
              </button>
            </div>

            <div class="col-auto"
              *ngIf="Type == 'Notice' && (RightsID.includes('202032001') || RightsID.includes('202032021')); else ConvertCase">
              <button class="btn btn-success w-100 action-btn" (click)="ConvertNoticeinCase()">
                <i class="fa fa-exchange"></i> Convert to Case
              </button>
            </div>
            <ng-template #ConvertCase>
              <div class="col-auto">
                <a routerLink="/module/0" class="btn btn-secondary w-100 action-btn">
                  <i class="fa fa-exchange"></i> Convert to Case
                </a>
              </div>
            </ng-template>

            <div class="col-auto"
              *ngIf="Type == 'Notice' && (RightsID.includes('202026001') || RightsID.includes('202026021'))">
              <button class="btn btn-warning text-dark w-100 action-btn" data-toggle="modal"
                (click)="OpenModal('expense','0','FetchExpenseDetail','Add Expense Detail')" data-target="#ModalPopUP">
                <i class="fa fa-money"></i> Add Expense
              </button>
            </div>

            <div class="col-auto"
              *ngIf="Type == 'Case' && (RightsID.includes('202026001') || RightsID.includes('202026021'))">
              <button class="btn btn-warning text-dark w-100 action-btn" data-toggle="modal"
                (click)="OpenModal('expense','0','FetchExpenseDetail','Add Expense Detail')" data-target="#ModalPopUP">
                <i class="fa fa-money"></i> Add Expense
              </button>
            </div>

            <div class="col-auto" *ngIf="ShowHideSharingOption != '1' && (Type == 'Notice' || Type == 'Case')">
              <button class="btn btn-primary w-100 action-btn" data-toggle="modal"
                (click)="OpenModal('evalentry', (Type=='Notice')?'2':'0', 'FetchExpenseDetail', 'Evaluation Form')"
                data-target="#ModalPopUP">
                <i class="fa fa-check-circle"></i> Evaluation
              </button>
            </div>

            <div class="col-auto" *ngIf="Type == 'Case' && ShowHideSharingOption != '1'">
              <a [routerLink]="['/casetransfer/case', id]" class="btn btn-secondary w-100 action-btn">
                <i class="fa fa-exchange"></i> Case Transfer
              </a>
            </div>

            <div class="col-auto" *ngIf="ShowHideSharingOption != '1'">
              <button class="btn btn-danger w-100 action-btn" (click)="CloseRecord()">
                <i class="fa fa-times-circle"></i> Close {{ Type }}
              </button>
            </div>

            <div class="col-auto" *ngIf="ShowHideSharingOption != '1'">
              <button class="btn btn-danger w-100 action-btn" (click)="FinalVerdict()">
                <i class="fa fa-gavel"></i> Final Verdict
              </button>
            </div>

            <div class="col-auto" *ngIf="Type == 'Case' && ShowHideSharingOption != '1'">
              <button class="btn btn-success w-100 action-btn" data-toggle="modal"
                (click)="OpenModal('sharingoption', '0', '', 'Sharing Option')" data-target="#ModalPopUP">
                <i class="fa fa-share-alt"></i> Sharing
              </button>
            </div>

          </ng-container>
        </ng-container>
      </div>
      } -->



      <div>
        <div class="my-3 text-center">
          <ul class="nav nav-tabs custom-tabs">
            <li>
              <a *ngIf="
                  (this.Type == 'Case' && this.chequeBounceCase == '1') ||
                  (this.Type == 'Notice' && this.chequeBounceNotice == '1')
                " data-toggle="tab" class="tab-title" href="#ChequeBouncing"><b>Cheque Bouncing Details</b></a>
            </li>
            <!-- <li class="active">
              <a data-toggle="tab" class="tab-title" href="#Fact"><b>Fact Sheet</b></a>
            </li> -->
            <li class="active">
              <a data-toggle="tab" class="tab-title" href="#Contacts"><b>Contact</b></a>
            </li>
            <li>
              <a data-toggle="tab" class="tab-title" href="#ProductCause"><b>Product/Cause</b></a>
            </li>
            <li>
              <a data-toggle="tab" class="tab-title" href="#PlanDiary"><b>{{ Type }} History</b></a>
            </li>
            <li>
              <a data-toggle="tab" class="tab-title" href="#Expense"><b>Expense</b></a>
            </li>
            <!-- <li><a data-toggle="tab" class="tab-title" href="#todealwith"><b>To Deal With</b></a></li> -->
            <li>
              <a data-toggle="tab" class="tab-title" href="#Log"><b>Log</b></a>
            </li>
          </ul>
        </div>

        <!-- modal-dialog-Contact-Start -->
        <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
          <div class="modal-dialog-FactSheet">
            <div class="modal-content">
              <div class="modal-header BlueHeader">
                <h4 class="Heading">{{ ModelFor }}</h4>
                <br />
                <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()" data-dismiss="modal">
                  &times;
                </button>
              </div>
              <div class="modal-body col-sm-12 form-group">
                <iframe  class="modal-frame" frameBorder="0" [src]="modalURL | safe"></iframe>
              </div>
            </div>
          </div>
        </div>
        <!-- modal-dialog-Contact-End -->

        <!-- <div class=""> -->
        <div class="tab-content">
          @if(true){
          <div id="ChequeBouncing" class="tab-pane fade">
            @if ((Type == 'Case' && chequeBounceCase == '1') || (Type == 'Notice' && chequeBounceNotice == '1')) {
            <div class="card rounded-4 border-0">
              <div class="card-body">
                <form [formGroup]="ChequeBouncingForm" (ngSubmit)="onChequeBouncingUpdate(ChequeBouncingForm.value)">
                  <div class="page-sub-heading">
                    Cheque Bouncing Details
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="AmountDue" class="form-label">Amount Due <span class="text-danger">*</span></label>
                        <input type="number" class="form-control" (change)="onChangeAmountDue($event.target.value)"
                          formControlName="AmountDue" placeholder="Amount Due">
                          @if (c.AmountDue.touched && c.AmountDue.invalid) {
                            <div class="text-danger">
                              <small>Amount Due is required.</small>
                            </div>
                          }
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="DateofReceivingAmount" class="form-label">Date of Receiving Amount <span class="text-danger">*</span></label>
                        <mat-form-field class="fullwidth" appearance="outline">
                          <input matInput [matDatepicker]="DateofReceivingAmount"
                            formControlName="DateofReceivingAmount" placeholder="Date of Receiving Amount">
                          <mat-datepicker-toggle matSuffix [for]="DateofReceivingAmount"></mat-datepicker-toggle>
                          <mat-datepicker #DateofReceivingAmount></mat-datepicker>
                          @if (c.DateofReceivingAmount.touched && c.DateofReceivingAmount.invalid) {
                            <mat-error>Date of Receiving Amount is required.</mat-error>
                          }
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="ReceivingAmount" class="form-label">Receiving Amount <span class="text-danger">*</span></label>
                        <input type="number" class="form-control" formControlName="ReceivingAmount"
                          placeholder="Receiving Amount" (change)="onChangeReceivingAmount($event.target.value)">
                          @if (c.ReceivingAmount.touched && c.ReceivingAmount.invalid) {
                            <div class="text-danger">
                              <small>Receiving Amount is required.</small>
                            </div>
                          }
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="ModeOfPayment" class="form-label">Mode of Payment <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" formControlName="ModeOfPayment"
                          placeholder="Mode of Payment">
                          @if (c.ModeOfPayment.touched && c.ModeOfPayment.invalid) {
                            <div class="text-danger">
                              <small>Mode of Payment is required.</small>
                            </div>
                          }
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="againstchequebouncing" class="form-label">O/S against cheque bouncing <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" formControlName="againstchequebouncing">
                          @if (c.againstchequebouncing.touched && c.againstchequebouncing.invalid) {
                            <div class="text-danger">
                              <small>O/S against cheque bouncing is required.</small>
                            </div>
                          }
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="TotalOSFromParty" class="form-label">Total O/S From Party <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" formControlName="TotalOSFromParty">
                          @if (c.TotalOSFromParty.touched && c.TotalOSFromParty.invalid) {
                            <div class="text-danger">
                              <small>Total O/S From Party is required.</small>
                            </div>
                          }
                      </div>
                    </div>
                  </div>
                  <div class="page-sub-heading mt-2">
                    Payment Details
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="ChequeDate" class="form-label">Cheque Date <span class="text-danger">*</span> </label>
                        <mat-form-field class="fullwidth" appearance="outline">
                          <input matInput [matDatepicker]="ChequeDate" formControlName="ChequeDate"
                            placeholder="Cheque Date">
                          <mat-datepicker-toggle matSuffix [for]="ChequeDate"></mat-datepicker-toggle>
                          <mat-datepicker #ChequeDate></mat-datepicker>
                        </mat-form-field>
                        @if (c.ChequeDate.touched && c.ChequeDate.invalid) {
                          <div class="text-danger">
                            <small>Cheque Date is required.</small>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="ChequeNo" class="form-label">Cheque No. <span class="text-danger">*</span> </label>
                        <input type="text" class="form-control" formControlName="ChequeNo" placeholder="Cheque No.">
                          @if (c.ChequeNo.touched && c.ChequeNo.invalid) {
                            <div class="text-danger">
                              <small>Cheque No. is required.</small>
                            </div>
                          }
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="ChequeAmount" class="form-label">Cheque Amount <span class="text-danger">*</span> </label>
                        <input type="number" class="form-control" formControlName="ChequeAmount"
                          placeholder="Cheque Amount">
                          @if (c.ChequeAmount.touched && c.ChequeAmount.invalid) {
                            <div class="text-danger">
                              <small>Cheque Amount is required.</small>
                            </div>
                          }
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="DishonorDate" class="form-label">Dishonor Date <span class="text-danger">*</span> </label>
                        <mat-form-field class="fullwidth" appearance="outline">
                          <input matInput [matDatepicker]="DishonorDate" formControlName="DishonorDate"
                            placeholder="Select Dishonor Date">
                          <mat-datepicker-toggle matSuffix [for]="DishonorDate"></mat-datepicker-toggle>
                          <mat-datepicker #DishonorDate></mat-datepicker>
                          @if (c.DishonorDate.touched && c.DishonorDate.invalid) {
                            <mat-error>Dishonor Date is required.</mat-error>
                          }
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="DishonorReason" class="form-label">Dishonor Reason</label>
                        <textarea class="form-control" formControlName="DishonorReason" rows="2"
                          placeholder="Dishonor Reason"></textarea>
                        <!-- <input type="text" class="form-control" formControlName="DishonorReason"
                          placeholder="Dishonor Reason"> -->
                          @if (c.DishonorReason.touched && c.DishonorReason.invalid) {
                            <div class="text-danger">
                              <small>Dishonor Reason is required.</small>
                            </div>
                          }
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="DishonorBank" class="form-label">Dishonor Bank</label>
                        <input type="text" class="form-control" formControlName="DishonorBank"
                          placeholder="Dishonor Bank">
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="DishonorBankBranch" class="form-label">Dishonor Bank Branch</label>
                        <input type="text" class="form-control" formControlName="DishonorBankBranch"
                          placeholder="Dishonor Bank Branch">
                      </div>
                    </div>

                  </div>
                  @if ((Type == 'Case' && RightsID.includes('202032001')) ||
                       (Type == 'Case' && RightsID.includes('202032021')) ||
                       (Type == 'Notice' && RightsID.includes('202030001')) ||
                       (Type == 'Notice' && RightsID.includes('202030021'))) {
                  <div class="d-flex align-items-center justify-content-center mt-3" [hidden]="HideContent" >
                    <button class="btn btn-primary submit-btn" type="submit">
                      Update
                    </button>
                  </div>
                  }
                </form>
              </div>
            </div>
            }
          </div>
          }
          <!-- @if (false) {
          <div id="ChequeBouncing" class="tab-pane fade" *ngIf="
                  (this.Type == 'Case' && this.chequeBounceCase == '1') ||
                  (this.Type == 'Notice' && this.chequeBounceNotice == '1')
                ">
            <div class="col-sm-12"></div>
            <form #UpdateChequeBouncing="ngForm" [formGroup]="ChequeBouncingForm"
              (ngSubmit)="onChequeBouncingUpdate(UpdateChequeBouncing.value)">
              <div class="col-sm-12" style="margin-top: 8px">
                <div class="col-sm-12 lefticonD paddingless" style="
                        border-left: 1px solid #ccc;
                        border-top: 1px solid #ccc;
                        border-right: 1px solid #ccc;
                      ">
                  <label>Cheque Bouncing Details </label>
                </div>
                <table width="100%" class="LMtable_lite entry fullwidth LMtable">
                  <tr>
                    <td width="10%">Amount Due</td>
                    <td width="23%">
                      <div class="col-sm-11">
                        <input type="text" formControlName="AmountDue" class="form-control"
                          (change)="onChangeAmountDue($event.target.value)" name="AmountDue" type="number" value="" />
                      </div>
                    </td>
                    <td width="10%">Date of Receiving Amount</td>
                    <td width="24%">
                      <div class="col-sm-11">
                        <mat-form-field class="fullwidth">
                          <input matInput [readonly]="!editable" [min]="minDate" formControlName="DateofReceivingAmount"
                            [max]="maxDate" [matDatepicker]="picker8" placeholder="Choose a Receiving Amount Date" />
                          <mat-datepicker-toggle matSuffix [for]="picker8">
                          </mat-datepicker-toggle>
                          <mat-datepicker #picker8></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </td>
                    <td width="10%">Receiving Amount</td>
                    <td width="23%">
                      <div class="col-sm-11">
                        <input type="text" formControlName="ReceivingAmount" class="form-control" (change)="
                                onChangeReceivingAmount($event.target.value)
                              " type="number" value="" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Mode Of Payment</td>
                    <td>
                      <div class="col-sm-11">
                        <input type="text" formControlName="ModeOfPayment" class="form-control" />
                      </div>
                    </td>
                    <td>O/S against cheque bouncing</td>
                    <td>
                      <div class="col-sm-11">
                        <input class="form-control" formControlName="againstchequebouncing" type="number" value="" />
                      </div>
                    </td>
                    <td>Total O/S From Party</td>
                    <td>
                      <div class="col-sm-11">
                        <input class="form-control" formControlName="TotalOSFromParty" type="number" value="" />
                      </div>
                    </td>
                  </tr>
                </table>

                <div class="col-sm-12 lefticonD paddingless" style="
                        margin-top: 8px;
                        border-left: 1px solid #ccc;
                        border-top: 1px solid #ccc;
                        border-right: 1px solid #ccc;
                      ">
                  <label>Payment Details </label>
                </div>
                <table width="100%" class="LMtable_lite entry fullwidth LMtable">
                  <tr>
                    <td width="10%">Cheque Date</td>
                    <td width="23%">
                      <div class="col-sm-11">
                        <mat-form-field class="fullwidth">
                          <input matInput [readonly]="!editable" [min]="minDate" formControlName="ChequeDate"
                            [max]="maxDate" [matDatepicker]="picker6" placeholder="Choose a Cheque Date" />
                          <mat-datepicker-toggle matSuffix [for]="picker6">
                          </mat-datepicker-toggle>
                          <mat-datepicker #picker6></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </td>
                    <td>Cheque No.</td>
                    <td>
                      <div class="col-sm-11">
                        <input class="form-control" formControlName="ChequeNo" name="ChequeNo" type="text" value="" />
                      </div>
                    </td>
                    <td>Cheque Amount</td>
                    <td>
                      <div class="col-sm-11">
                        <input class="form-control" formControlName="ChequeAmount" type="number" value="" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Dishonor Date</td>
                    <td>
                      <div class="col-sm-11">
                        <mat-form-field class="fullwidth">
                          <input matInput [readonly]="!editable" [min]="minDate" formControlName="DishonorDate"
                            [max]="maxDate" [matDatepicker]="picker7" placeholder="Choose a Dishonor Date" />
                          <mat-datepicker-toggle matSuffix [for]="picker7">
                          </mat-datepicker-toggle>
                          <mat-datepicker #picker7></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </td>
                    <td>Dishonor Reason</td>
                    <td>
                      <div class="col-sm-11">
                        <input type="text" formControlName="DishonorReason" class="form-control" />
                      </div>
                    </td>
                    <td>Dishonor Bank</td>
                    <td>
                      <div class="col-sm-11">
                        <input type="text" formControlName="DishonorBank" class="form-control" />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Dishonor Bank Branch</td>
                    <td>
                      <div class="col-sm-11">
                        <input type="text" formControlName="DishonorBankBranch" class="form-control" />
                      </div>
                    </td>
                  </tr>
                </table>
                <div class="col-sm-12" style="padding-top: 10px">
                  <div class="col-sm-5"></div>
                  <div [hidden]="HideContent" *ngIf="
                          (this.Type == 'Case' &&
                            this.RightsID.includes('202032001')) ||
                            (this.Type == 'Case' &&
                              this.RightsID.includes('202032021')) ||
                            (this.Type == 'Notice' &&
                              this.RightsID.includes('202030001')) ||
                            (this.Type == 'Notice' &&
                              this.RightsID.includes('202030021'));
                          then ChequeBouncingUpdateLink;
                          else ChequeBouncingUpdate
                        "></div>
                  <ng-template #ChequeBouncingUpdateLink>
                    <div class="col-sm-2" [hidden]="HideContent">
                      <button style="align-items: center" class="btn btn-primary">
                        Update
                      </button>
                    </div>
                  </ng-template>
                  <ng-template #ChequeBouncingUpdate>
                    <div class="col-sm-2">&nbsp;</div>
                  </ng-template>

                  <div class="col-sm-5"></div>
                </div>
              </div>
            </form>
          </div>
          } -->

          <!-- <div id="Fact" class="tab-pane fade in active"> -->
            @if (true) {
            <!-- <div class="card rounded-4 border-0">
              <div class="card-body">
                @if (!HideContent && (Type == 'Case' && RightsID.includes('202032001')) || (Type == 'Case' &&
                RightsID.includes('202032021')) ||( Type == 'Notice' && RightsID.includes('202030001') || (Type ==
                'Notice' && RightsID.includes('202030021')))) {
                <div class="text-end">
                  <button type="button" class="btn btn-primary font-14 btn-sm mb-2" data-toggle="modal" (click)="
                              OpenModal(
                                'afsc',
                                '0',
                                'factSheetData',
                                'Add Fact Sheet'
                              )
                            " data-target="#ModalPopUP">
                    <i class="fa fa-plus"></i>
                    Add Fact Sheet
                  </button>
                </div>
                <div class="card">
                  <table class="custom-table">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Date</th>
                        <th>Event Description</th>
                        <th>Update By</th>
                        <th>Files</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                     <app-table-state
                      [empty]="factsheetDetail?.length == 0"
                      [rows]="5"
                      [columns]="6"></app-table-state>
                    <tbody>
                      @if(factsheetDetail?.length>0){
                        @for (fsD of factsheetDetail; track $index ;let i = $index){
                        <tr>
                          <td>{{i+1}}</td>
                          <td>{{fsD.fDate | date: 'dd-MMM-yyyy'}}</td>
                          <td>{{fsD.description}}</td>
                          <td>{{fsD.UserName}}</td>
                          <td>
                            @if(fsD?.attachment?.length>0){
                              @for (fsDFile of fsD.attachment; track $index) {
                              <div>
                                <a href="{{ DownloadURL }}{{ fsDFile.DownloadPath }}">{{ fsDFile.DisplayName }}</a>
                                @if ((Type == 'Notice' && RightsID.includes('202030001')) || (Type == 'Notice' &&
                                RightsID.includes('202030021'))) {
                                  <button class="icon-btn icon-btn-danger ml-2" (click)="DeleteAttachment(fsDFile.ID)">
                                    <a class="icon-btn icon-btn-danger" (click)="DeleteAttachment(fsD.ID)">
                                      <i class="fa fa-trash"></i></a></button>
                                
                                }@else {
                                <a class="icon-btn icon-btn-danger ml-2" routerLink="/module/0"><i
                                    class="fa fa-trash"></i></a>
                                }
                              </div>
                              }
                            }
                          </td>
                          <td>
                            <button class="icon-btn icon-btn-primary" routerLink="/module/0">
                              <i class="fa fa-eye"></i>
                            </button>
                          </td>
                        </tr>
                        }
                      }
                    </tbody>
                  </table>
                </div>
                } @else {
                <div class="text-end">
                  <a class="btn btn-link btn-sm" routerLink="/module/0">Add Fact Sheet</a>
                </div>
                }
              </div>
            </div> -->
            }@else {
            <!-- <div class="col-sm-12">
              <div class="col-sm-12">&nbsp;</div>
              <div [hidden]="HideContent" *ngIf="
                      (this.Type == 'Case' &&
                        this.RightsID.includes('202032001')) ||
                        (this.Type == 'Case' &&
                          this.RightsID.includes('202032021')) ||
                        (this.Type == 'Notice' &&
                          this.RightsID.includes('202030001')) ||
                        (this.Type == 'Notice' &&
                          this.RightsID.includes('202030021'));
                      then FactAddLink;
                      else FactAdd
                    "></div>
              <ng-template #FactAddLink>
                <div [hidden]="HideContent">
                  <button type="button" class="btn btn-primary font-14 btn-sm mb-2" data-toggle="modal" (click)="
                          OpenModal(
                            'afsc',
                            '0',
                            'factSheetData',
                            'Add Fact Sheet'
                          )
                        " data-target="#ModalPopUP">
                    <i class="fa fa-plus"></i>
                    Add Fact Sheet
                  </button>
                </div>
              </ng-template>
              <ng-template #FactAdd>
                <div [hidden]="HideContent">
                  <a class="btn btn-link btn-sm" routerLink="/module/0">Add Fact Sheet</a>
                </div>
              </ng-template>

              <table class="fullwidth LMtable">
                <tr>
                  <th>S.No.</th>
                  <th>Date</th>
                  <th>Event Description</th>
                  <th>Update By</th>
                  <th>Files</th>
                  <th>Action</th>
                </tr>
                <tr style="border: lightgray solid 1px" *ngFor="let fsD of factsheetDetail; let i = index">
                  <td align="center">{{ i + 1 }}</td>
                  <td>{{ fsD.fDate | date : "dd-MMM-yyyy" }}</td>
                  <td>{{ fsD.description }}</td>
                  <td>{{ fsD.UserName }}</td>
                  <td>
                    <table>
                      <tr *ngFor="let fsDFile of fsD.attachment; let i = index">
                        <td>
                          <a href="{{ DownloadURL }}{{ fsDFile.DownloadPath }}">{{ fsDFile.DisplayName }}</a>
                        </td>
                        <td>
                          <a *ngIf="
                                  (this.Type == 'Notice' &&
                                    this.RightsID.includes('202030021')) ||
                                    (this.Type == 'Case' &&
                                      this.RightsID.includes('202032021'));
                                  then DelFactFileLink;
                                  else DelFactFile
                                ">
                          </a>
                          <ng-template #DelFactFileLink>
                            <a (click)="DeleteAttachment(fsDFile.ID)">
                              <i class="fa fa-trash font-16 text-danger cursor-pointer "></i>
                            </a>
                          </ng-template>
                          <ng-template #DelFactFile>
                            <a routerLink="/module/0">
                              <i class="fa fa-trash font-16 text-danger cursor-pointer "></i>
                            </a>
                          </ng-template>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td>
                    <a *ngIf="
                            (this.Type == 'Notice' &&
                              this.RightsID.includes('202030021')) ||
                              (this.Type == 'Case' &&
                                this.RightsID.includes('202032021'));
                          then DelFactLink;
                          else DelFact;
                          ">
                    </a>
                    <ng-template #DelFactLink>
                      <a title="Delete" (click)="deleteFActSheet(fsD.id)">
                        <i class="fa fa-trash font-16 text-danger cursor-pointer "></i>
                      </a>
                    </ng-template>
                    <ng-template #DelFact>
                      <a routerLink="/module/0"><img src="assets/resources/images/delete.gif " /></a>
                    </ng-template>
                  </td>
                </tr>
              </table>
            </div> -->
            }
            <!--Fact Sheet Form End-->
          <!-- </div> -->
          <div id="Contacts" class="tab-pane fade in active">
            <!--Contact Form Start-->
            @if(true){
            <div class="card">
              <div class="card-body">
                <form [formGroup]="addFormOrgContact" (ngSubmit)="onOrgContactSubmit(addFormOrgContact.value)">
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <ng-select [items]="ContactList" [clearable]="false" [multiple]="false"
                        formControlName="OrgContactName" bindLabel="Name" [selectableGroup]="true"
                        placeholder="Select Contact" [closeOnSelect]="true" bindValue="ID">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          {{ item.Name }} {{ item.City }} {{ item.State }}
                        </ng-template>
                      </ng-select>
                    </div>
                    @if ((Type == 'Case' && RightsID.includes('202032001')) || (Type == 'Case' &&
                    RightsID.includes('202032021')) || (Type == 'Notice' && RightsID.includes('202030001')) || (Type ==
                    'Notice' && RightsID.includes('202030021'))) {
                    <div class="col-auto" [hidden]="HideContent" >
                      <button class="btn btn-primary" type="submit"> <i class="fa fa-plus"></i> Add to List</button>
                    </div>
                    }
                    <div class="col-auto ms-auto" [hidden]="HideContent" >
                      <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#ModalPopUP"  (click)="
                                  OpenModal(
                                    '/acc',
                                    '0',
                                    'FetchContactDetail',
                                    'Add Contact'
                                  )
                                "> <i class="fa fa-plus"></i>  Add New Contact</button>
                    </div>
                  </div>
                </form>
                <div class="card mt-3">
                  <table class="custom-table">
                    <thead>
                      <tr>
                          <th>S.No.</th>
                          <th>Designation</th>
                          <th>Department</th>
                          <th>Name</th>
                          <th>Customer Code</th>
                          <th>Mobile No</th>
                          <th>Contact No</th>
                          <th>Email ID</th>
                          <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <app-table-state
                      [empty]="FetchContactRecord?.length == 0 || FetchContactRecord == null"
                      [rows]="5"
                      [columns]="9"></app-table-state>
                      @if (FetchContactRecord?.length > 0) {
                        @for (ContactDetailData of FetchContactRecord; track $index; let i = $index) {
                        <tr>
                          <td>{{ i + 1 }}</td>
                          <td>{{ ContactDetailData.Designation }}</td>
                          <td>{{ ContactDetailData.Department }}</td>
                          <td>{{ ContactDetailData.Name }}</td>
                          <td>{{ ContactDetailData.CustomerCode }}</td>
                          <td>{{ ContactDetailData.Mobile }}</td>
                          <td>{{ ContactDetailData.WorkPhone1 }}</td>
                          <td>{{ ContactDetailData.Email1 }}</td>
                          <td>
                            @if (RightsID.includes('202034001') || RightsID.includes('202034021')) {
                              <a class="icon-btn icon-btn-primary text-decoration-none" target="_blank" title="Edit" routerLink="/addorgcontact/Contact/{{ ContactDetailData.ContactID  }}">
                                <i class="fa fa-pencil"></i>
                              </a>
                            } @else {
                              <a class="icon-btn icon-btn-primary text-decoration-none" target="_blank" title="Edit" routerLink="/module/0">
                                <i class="fa fa-pencil"></i>
                              </a>
                            }
                            @if ( (Type == 'Notice' && RightsID.includes('202030021')) ||  (Type == 'Case' && RightsID.includes('202032021')) ) {
                              <button class="icon-btn icon-btn-danger ml-2" title="Delete" (click)="deleteNoticeContact(ContactDetailData.ID)">
                                  <i class="fa fa-trash"></i>
                              </button>
                            }@else {
                              <button class="icon-btn icon-btn-danger ml-2" title="Delete">
                                <a  routerLink="/module/0">
                                  <i class="fa fa-trash"></i>
                                </a>
                              </button>
                            }
                          </td>
                        </tr>
                        }
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            }@else {
            <!-- <div class="col-sm-12">&nbsp;</div>
            <div class="col-sm-12">
              <table class="fullwidth LMtable">
                <tr>
                  <td colspan="10" style="padding: 15px">
                    <div class="col-sm-6">
                      <div class="col-sm-1" style="padding: 5px">
                        <label>Select:</label>
                      </div>
                      <div class="col-sm-8">
                        <form #AddOrgContact="ngForm" [formGroup]="addFormOrgContact"
                          (ngSubmit)="onOrgContactSubmit(AddOrgContact.value)">
                          <div class="col-sm-9">
                            <ng-select [items]="ContactList" [clearable]="false" [multiple]="false"
                              formControlName="OrgContactName" bindLabel="Name" [selectableGroup]="true"
                              [closeOnSelect]="true" bindValue="ID">
                              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                {{ item.Name }}&nbsp;&nbsp;&nbsp;({{
                                item.State
                                }},{{ item.City }})&nbsp;&nbsp;&nbsp;({{
                                item.Mobile
                                }})
                              </ng-template>
                            </ng-select>
                          </div>
                          <div [hidden]="HideContent" *ngIf="
                                  (this.Type == 'Case' &&
                                    this.RightsID.includes('202032001')) ||
                                    (this.Type == 'Case' &&
                                      this.RightsID.includes('202032021')) ||
                                    (this.Type == 'Notice' &&
                                      this.RightsID.includes('202030001')) ||
                                    (this.Type == 'Notice' &&
                                      this.RightsID.includes('202030021'));
                                  then ContactButtonLink;
                                  else ContactButton
                                "></div>
                          <ng-template #ContactButtonLink>
                            <div class="col-sm-3" [hidden]="HideContent">
                              <input class="btn btn-primary btn-sm font-14" type="submit" value="Add to List" />
                            </div>
                          </ng-template>
                          <ng-template #ContactButton>
                            <div class="col-sm-3">&nbsp;</div>
                          </ng-template>
                        </form>
                      </div>
                      <div [hidden]="HideContent" *ngIf="
                              this.RightsID.includes('202034001') ||
                                this.RightsID.includes('202034021');
                              then ContactPageLink;
                              else ContactPage
                            "></div>
                      <ng-template #ContactPageLink>
                        <div class="col-sm-2" [hidden]="HideContent">
                          <button type="button" class="btn btn-link btn-sm font-14 " data-toggle="modal" (click)="
                                  OpenModal(
                                    '/acc',
                                    '0',
                                    'FetchContactDetail',
                                    'Add Contact'
                                  )
                                " data-target="#ModalPopUP">
                            Add New Contact
                          </button>
                        </div>
                      </ng-template>
                      <ng-template #ContactPage>
                        <div class="col-sm-2">&nbsp;</div>
                      </ng-template>

                      <div class="col-sm-1"></div>
                    </div>
                    <div class="col-sm-6"></div>
                  </td>
                </tr>
                <tr>
                  <th>S.No.</th>
                  <th>Designation</th>
                  <th>Department</th>
                  <th>Name</th>
                  <th>Customer Code</th>
                  <th>Mobile No</th>
                  <th>Contact No</th>
                  <th>Email ID</th>
                  <th colspan="2">Action</th>
                </tr>
                <tr style="border: lightgray solid 1px" *ngFor="
                        let ContactDetailData of FetchContactRecord;
                        let i = index
                      ">
                  <td align="center">{{ i + 1 }}</td>
                  <td>{{ ContactDetailData.Designation }}</td>
                  <td>{{ ContactDetailData.Department }}</td>
                  <td>{{ ContactDetailData.Name }}</td>
                  <td>{{ ContactDetailData.CustomerCode }}</td>
                  <td>{{ ContactDetailData.Mobile }}</td>
                  <td>{{ ContactDetailData.WorkPhone1 }}</td>
                  <td>{{ ContactDetailData.Email1 }}</td>
                  <td>
                    <a *ngIf="
                            this.RightsID.includes('202034001') ||
                              this.RightsID.includes('202034021');
                            then EditContactLink;
                            else EditContact
                          ">
                    </a>

                    <ng-template #EditContactLink>
                      <a target="_blank" title="Edit" routerLink="/addorgcontact/Contact/{{
                              ContactDetailData.ContactID
                            }}">
                        <i class="fa fa-pencil font-16 theme-icon"></i>
                      </a>
                    </ng-template>
                    <ng-template #EditContact>
                      <a routerLink="/module/0">
                        <i class="fa fa-pencil font-16 theme-icon"></i>
                      </a>
                    </ng-template>
                  </td>
                  <td>
                    <a *ngIf="
                            (this.Type == 'Notice' &&
                              this.RightsID.includes('202030021')) ||
                              (this.Type == 'Case' &&
                                this.RightsID.includes('202032021'));
                            then DelContactLink;
                            else DelContact
                          ">
                    </a>
                    <ng-template #DelContactLink>
                      <a title="Delete" (click)="deleteNoticeContact(ContactDetailData.ID)">
                        <i class="fa fa-trash font-16 text-danger cursor-pointer "></i>
                      </a>
                    </ng-template>
                    <ng-template #DelContact>
                      <a routerLink="/module/0">
                        <i class="fa fa-trash font-16 text-danger cursor-pointer "></i>
                      </a>
                    </ng-template>
                  </td>
                </tr>
              </table>
            </div> -->
            }

            <!--Contact Form End-->
          </div>
          <div id="ProductCause" class="tab-pane fade">
            <!-- Product Form Start-->
             @if(true){
               <div class="card">
              <div class="card-body">
                <form [formGroup]="addFormProduct" (ngSubmit)="onProductADD(addFormProduct.value)">
                  <div class="row">
                    <div class="col-12 col-md-4">
                       <ng-select [items]="ProductHelpList" [clearable]="false" [multiple]="false"
                         formControlName="HelpProduct" bindLabel="MainDescr" [selectableGroup]="true"
                         [closeOnSelect]="true" bindValue="hdID">
                         <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                           {{ item.MainDescr }}
                         </ng-template>
                       </ng-select>
                    </div>
                    @if (
                        (Type == 'Case' && RightsID.includes('202032001')) ||
                        (Type == 'Case' && RightsID.includes('202032021')) || 
                        (Type == 'Notice' && RightsID.includes('202030001')) || 
                        (Type == 'Notice' && RightsID.includes('202030021'  ))
                    ) {
                        <div class="col-auto" [hidden]="HideContent" >
                          <button type="submit" class="btn btn-primary " [disabled]="!addFormProduct.valid">
                            <i class="fa fa-plus"></i> Add
                          </button>
                        </div>
                      }
                  </div>
                </form>
                <form [formGroup]="dynamicProductForm" (ngSubmit)="onProductUpdate()">
                <div class="card mt-3">
                     <table class="custom-table">
                       <thead>
                         <tr>
                           <th>S.No.</th>
                           <th>Product Name</th>
                           <th>Product Code</th>
                           <th>Description</th>
                           <th>Action</th>
                         </tr>
                       </thead>
                       <tbody>
                      <app-table-state
                      [empty]="t?.controls?.length  == 0"
                      [rows]="5"
                      [columns]="5"></app-table-state>
                        @if (t?.controls?.length > 0) {
                          @for (ProductForm of t.controls; track $index; let i = $index) {
                            <tr [formGroup]="ProductForm" >
                             <td> {{ i + 1 }}</td>
                             <td>
                              {{ ProductForm.get('ProductName').value }}
                             </td>
                             <td>
                              {{ ProductForm.get('ProductCode').value }}
                             </td>
                             <td>
                               <textarea type="text" placeholder="Enter Description here" formControlName="Remarks" class="TextareafullSize form-control"></textarea>
                             </td>
                             <td>
                               @if ((Type == 'Notice' && RightsID.includes('202030021')) || (Type == 'Case' && RightsID.includes('202032021'))) {
                                <button type="button" class="icon-btn icon-btn-danger"  title="Delete" (click)="DeleteNoticeProduct(i)">
                                  <i class="fa fa-trash"></i>
                                </button>
                               }@else {
                                <a class="icon-btn icon-btn-danger" type="button" routerLink="/module/0">
                                  <i class="fa fa-trash"></i>
                                </a>
                               }
                             </td>
                            </tr>
                          }
                        }

                       </tbody>
                     </table>
                    </div>

                     @if ( (Type === 'Case' && RightsID.includes('202032001')) ||
                     (Type === 'Case' && RightsID.includes('202032021')) ||
                     (Type === 'Notice' && RightsID.includes('202030001')) ||
                     (Type === 'Notice' && RightsID.includes('202030021'))) {
                     <div class="d-flex align-items-center justify-content-center my-3" [hidden]="HideContent" >
                       <button class="btn btn-primary submit-btn small" type="submit" >
                         Update
                       </button>
                     </div>
                     }
                </form>
              </div>
            </div>
             }@else {
               <!-- <div class="col-sm-12 paddingles">
                 <div class="col-sm-12">&nbsp;</div>
   
                 <div class="col-sm-6">
                   <div class="col-sm-1" style="padding: 10px">
                     <label>Select:</label>
                   </div>
                   <form #AddProduct="ngForm" [formGroup]="addFormProduct" (ngSubmit)="onProductADD(AddProduct.value)">
                     <div class="col-sm-8">
                       <ng-select [items]="ProductHelpList" [clearable]="false" [multiple]="false"
                         formControlName="HelpProduct" bindLabel="MainDescr" [selectableGroup]="true"
                         [closeOnSelect]="true" bindValue="hdID">
                         <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                           {{ item.MainDescr }}
                         </ng-template>
                       </ng-select>
                     </div>
                     <div [hidden]="HideContent" *ngIf="
                           (this.Type == 'Case' &&
                             this.RightsID.includes('202032001')) ||
                             (this.Type == 'Case' &&
                               this.RightsID.includes('202032021')) ||
                             (this.Type == 'Notice' &&
                               this.RightsID.includes('202030001')) ||
                             (this.Type == 'Notice' &&
                               this.RightsID.includes('202030021'));
                           then ProductButtonLink;
                           else ProductButton
                         "></div>
                     <ng-template #ProductButtonLink>
                       <div class="col-sm-3" [hidden]="HideContent">
                         <input class="btn btn-primary btn-sm" type="submit" value="Add" />
                       </div>
                     </ng-template>
                     <ng-template #ProductButton>
                       <div class="col-sm-3">&nbsp;</div>
                     </ng-template>
                   </form>
                 </div>
                 <div class="col-sm-6"></div>
                 <div class="col-sm-12"></div>
                 <form [formGroup]="dynamicProductForm" (ngSubmit)="onProductUpdate()">
                   <div class="card m-3">
                     <div class="list-group list-group-flush">
                       <div class="list-group-item">
                         <div class="form-row" style="border: 1px solid #ccc; background-color: #eee">
                           <div class="form-group border-right col-1">
                             <label>S.No.</label>
                           </div>
                           <div class="form-group border-right col-3">
                             <label>Product Name</label>
                           </div>
                           <div class="form-group border-right col-3">
                             <label>Product Code</label>
                           </div>
                           <div class="form-group border-right col-3">
                             <label>Description</label>
                           </div>
                           <div class="form-group border-right col-1">&nbsp;</div>
                           <div class="form-group col-1">
                             <label>Action</label>
                           </div>
                         </div>
   
                         <div [formGroup]="ProductForm" class="form-row" style="
                               border-bottom: 1px solid #ccc;
                               border-left: 1px solid #ccc;
                               border-right: 1px solid #ccc;
                             " *ngFor="let ProductForm of t.controls; let i = index">
                           <div class="form-group border-right col-1">
                             {{ i + 1 }}
                           </div>
                           <div class="form-group border-right col-3">
                             <textarea type="text" formControlName="ProductName" class="TextareafullSize HideBorder"
                               readonly></textarea>
                           </div>
                           <div class="form-group border-right col-3">
                             <input type="text" formControlName="ProductCode" readonly class="HideBorder fullwidth" />
                           </div>
                           <div class="form-group border-right col-3">
                             <textarea type="text" formControlName="Remarks"
                               class="form-control TextareafullSize"></textarea>
                           </div>
                           <div class="form-group border-right col-1">&nbsp;</div>
                           <div class="form-group border-right col-1">
                             <a *ngIf="
                                   (this.Type == 'Notice' &&
                                     this.RightsID.includes('202030021')) ||
                                   (this.Type == 'Case' &&
                                     this.RightsID.includes('202032021'));
                                   then DelProductLink;
                                   else DelProduct
                                 ">
                             </a>
                             <ng-template #DelProductLink>
                               <a title="Delete" (click)="DeleteNoticeProduct(i)">
                                 <i class="fa fa-trash font-16 text-danger cursor-pointer "></i>
                               </a>
                             </ng-template>
                             <ng-template #DelProduct>
                               <a routerLink="/module/0"><img src="assets/resources/images/delete.gif " /></a>
                             </ng-template>
                           </div>
                         </div>
                         <div class="col-sm-12" style="padding-top: 10px">
                           <div class="col-sm-5"></div>
                           <div [hidden]="HideContent" *ngIf="
                                 (this.Type == 'Case' &&
                                   this.RightsID.includes('202032001')) ||
                                   (this.Type == 'Case' &&
                                     this.RightsID.includes('202032021')) ||
                                   (this.Type == 'Notice' &&
                                     this.RightsID.includes('202030001')) ||
                                   (this.Type == 'Notice' &&
                                     this.RightsID.includes('202030021'));
                                 then ProductUpdateLink;
                                 else ProductUpdate
                               "></div>
                           <ng-template #ProductUpdateLink>
                             <div class="col-sm-2" [hidden]="HideContent">
                               <button style="align-items: center" class="btn btn-primary">
                                 Update
                               </button>
                             </div>
                           </ng-template>
                           <ng-template #ProductUpdate>
                             <div class="col-sm-2">&nbsp;</div>
                           </ng-template>
   
                           <div class="col-sm-5"></div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </form>
               </div> -->
             }

            <!-- Product Form End-->
          </div>
          <!--Notice History-->
          <div id="PlanDiary" class="tab-pane fade">
            @if (true) {
              <div class="card">
                <table class="custom-table">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Date</th>
                        <th>Time from-To</th>
                        <th>Action Type</th>
                        <th>Action Taken</th>
                        <th>Urgent Files</th>
                        <th>Plan Date</th>
                        <th>Plan Description</th>
                        <th>Plan Responible User</th>
                        <th>Updated By</th>
                      </tr>
                    </thead>
                    <tbody>
                      <app-table-state
                      [loading]="false"
                      [error]="null"
                      [empty]="fetchNoticeHistoryData?.length == 0"
                      [rows]="10"
                      [columns]="10">
                      @if (fetchNoticeHistoryData?.length > 0) {
                        @for (FNHD of fetchNoticeHistoryData; track $index; let i = $index) {
                          <tr>
                            <td>{{ i + 1 }}</td>
                            <td>{{ FNHD.FollowDate | date : "dd-MMM-yyyy" }}</td>
                            <td>{{ FNHD.FollowInTime }}-{{ FNHD.FollowOutTime }}</td>
                            <td>{{ FNHD.FollowActionName }}</td>
                            <td>{{ FNHD.FollowActionTaken }}</td>
                            <td>
                              @if (FNHD?.attachment?.length > 0){
                                @for(FNHDFile of FNHD.attachment; track $index){
                                  <a href="{{ DownloadURL }}{{
                                    FNHDFile.DownloadPath
                                  }}" target="_blank">{{ FNHDFile.DisplayName }}</a>
                                  <button class="icon-btn icon-btn-danger" title="Delete" >
                                    <a (click)="DeleteAttachment(FNHDFile.ID)">
                                    <i class="fa fa-trash"></i>
                                    </a>
                                  </button>
                                }
                              }
                            </td>
                            <td>{{ FNHD.PlanDate | date : "dd-MMM-yyyy" }}</td>
                            <td>{{ FNHD.PlanActionTaken }}</td>
                            <td>{{ FNHD.ResponsibleUser }}</td>
                            <td>{{ FNHD.UserName }}</td>
                          </tr>
                        }
                      }
                      </app-table-state>
                    </tbody>
                </table>
              </div>
            } @else {
              <!-- <div class="col-sm-12 paddingles">
                <div class="col-sm-3">
                </div>
                <div class="col-sm-6"></div>
                <div class="col-sm-3"><br /></div>
                <br /><br />
                <table class="fullwidth LMtable">
                  <tr>
                    <th>S.No.</th>
                    <th>Date</th>
                    <th>Time from-To</th>
                    <th>Action Type</th>
                    <th>Action Taken</th>
                    <th>Urgent Files</th>
                    <th>Plan Date</th>
                    <th>Plan Description</th>
                    <th>Plan Responible User</th>
                    <th>Updated By</th>
                  </tr>
                  <tr style="border: lightgray solid 1px" *ngFor="let FNHD of fetchNoticeHistoryData; let i = index">
                    <td align="center">{{ i + 1 }}</td>
                    <td>
                      {{ FNHD.FollowDate | date : "dd-MMM-yyyy" }}
                    </td>
                    <td>{{ FNHD.FollowInTime }}-{{ FNHD.FollowOutTime }}</td>
                    <td>{{ FNHD.FollowActionName }}</td>
                    <td>{{ FNHD.FollowActionTaken }}</td>
                    <td>
                      <table>
                        <tr *ngFor="
                              let FNHDFile of FNHD.attachment;
                              let i = index
                            ">
                          <td>
                            <a href="{{ DownloadURL }}{{
                                  FNHDFile.DownloadPath
                                }}" target="_blank">{{ FNHDFile.DisplayName }}</a>
                          </td>
                          <td>
                            <a (click)="DeleteAttachment(FNHDFile.ID)">
                              <i class="fa fa-trash font-16 text-danger cursor-pointer "></i>
                            </a>
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td>
                      {{ FNHD.PlanDate | date : "dd-MMM-yyyy" }}
                    </td>
                    <td>{{ FNHD.PlanActionTaken }}</td>
                    <td>{{ FNHD.ResponsibleUser }}</td>
                    <td>{{ FNHD.UserName }}</td>
                  </tr>
                </table>
              </div> -->
            }
            <!--Notice History End-->
          </div>
          <div id="Expense" class="tab-pane fade">
            <!--Expense Form Start-->
            @if(true){
              <div class="card">
                  <table class="custom-table">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Date</th>
                        <th>User</th>
                        <th>Nature of Expense</th>
                        <th>Description</th>
                        <th>Units</th>
                        <th>Total</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <app-table-state
                      [loading]="false"
                      [error]="null"
                      [empty]="expenseDetail?.length == 0"
                      [rows]="10"
                      [columns]="8">
                      @if (expenseDetail?.length > 0){
                        @for(expenseDetailData of expenseDetail; track $index;let i = $index){
                          <tr>
                            <td>{{ i + 1 }}</td>
                            <td>{{ expenseDetailData.Date | date : "dd-MMM-yyyy" }}</td>
                            <td>{{ expenseDetailData.recUserName }}</td>
                            <td>{{ expenseDetailData.ExpenseNatureName }}</td>
                            <td>{{ expenseDetailData.Description }}</td>
                            <td>{{ expenseDetailData.UnitCount }}</td>
                            <td>{{ expenseDetailData.Value }}</td>
                            <td>
                              @if ( RightsID.includes('202026001') ||
                                RightsID.includes('202026021')) {
                                  <button class="icon-btn icon-btn-primary" title="Edit" data-toggle="modal" (click)="
                                      OpenModal(
                                        'expense',
                                        expenseDetailData.id,
                                        'FetchExpenseDetail',
                                        'Update Expense Detail'
                                      )
                                    " data-target="#ModalPopUP">
                                    <i class="fa fa-pencil"></i>
                                  </button>
                                }@else {
                                <a class="icon-btn icon-btn-primary" target="_blank" title="Edit" routerLink="/module/0">
                                  <i class="fa fa-pencil"></i>
                                </a>
                                }
                              @if (RightsID.includes('202026021')) {
                                <button class="icon-btn icon-btn-danger ml-2" title="Delete" (click)="DeleteExpense(expenseDetailData.id)">
                                  <i class="fa fa-trash "></i>
                                </button>
                              } @else {
                                <button class="icon-btn icon-btn-danger ml-2" title="Delete">
                                  <a routerLink="/module/0">
                                    <i class="fa fa-trash"></i>
                                  </a>
                                </button>
                              }
                            </td>
                          </tr>
                        }
                      }
                      </app-table-state>
                    </tbody>
                  </table>
                </div>
            } @else {
              <!-- <div class="col-sm-12 paddingles">
                <div class="col-sm-3">
                </div>
                <div class="col-sm-5"></div>
                <div class="col-sm-4"><br /></div>
                <br />
                <table class="LMtable" style="max-height: 200px; overflow-y: scroll; display: block">
                  <tr>
                    <th>S.No.</th>
                    <th>Date</th>
                    <th>User</th>
                    <th>Nature of Expense</th>
                    <th>Description</th>
                    <th>Units</th>
                    <th>Total</th>
                    <th colspan="2">Action</th>
                  </tr>
                  <tr style="border: lightgray solid 1px" *ngFor="
                        let expenseDetailData of expenseDetail;
                        let i = index
                      ">
                    <td align="center">{{ i + 1 }}</td>
                    <td>{{ expenseDetailData.Date | date : "dd-MMM-yyyy" }}</td>
                    <td>{{ expenseDetailData.recUserName }}</td>
                    <td>{{ expenseDetailData.ExpenseNatureName }}</td>
                    <td>{{ expenseDetailData.Description }}</td>
                    <td>{{ expenseDetailData.UnitCount }}</td>
                    <td>{{ expenseDetailData.Value }}</td>
                    <td>
                      <a *ngIf="
                            this.RightsID.includes('202026001') ||
                              this.RightsID.includes('202026021');
                            then EditExpenseLink;
                            else EditExpense
                          ">
                      </a>
                      <ng-template #EditExpenseLink>
                        <a href="#" title="Edit" data-toggle="modal" (click)="
                              OpenModal(
                                'expense',
                                expenseDetailData.id,
                                'FetchExpenseDetail',
                                'Update Expense Detail'
                              )
                            " data-target="#ModalPopUP">
                          <i class="fa fa-pencil font-16 theme-icon"></i>
                        </a>
                      </ng-template>
                      <ng-template #EditExpense>
                        <a routerLink="/module/0">
                          <img src="assets/resources/images/update.gif " />
                        </a>
                      </ng-template>
                    </td>
                    <td>
                      <a *ngIf="
                            this.RightsID.includes('202026021');
                            then DelExpenseLink;
                            else DelExpense
                          ">
                      </a>
                      <ng-template #DelExpenseLink>
                        <a title="Delete" (click)="DeleteExpense(expenseDetailData.id)">
                          <i class="fa fa-trash font-16 text-danger cursor-pointer "></i>
                        </a>
                      </ng-template>
                      <ng-template #DelExpense>
                        <a routerLink="/module/0"><img src="assets/resources/images/delete.gif " /></a>
                      </ng-template>
                    </td>
                  </tr>
                </table>
              </div> -->
            }
            <!--Expense Form End-->
          </div>
          <div id="Log" class="tab-pane fade">
            @if (true) {
                <div class="card">
                  <table class="custom-table">
                    <thead>
                      <tr>
                      <th>S.No.</th>
                      <th>Date</th>
                      <th>Change Description</th>
                      <th>Updated By</th>
                      </tr>
                    </thead>
                    <tbody>
                       <app-table-state
                      [loading]="false"
                      [error]="null"
                      [empty]="LogData?.length == 0 || LogData == null"
                      [rows]="10"
                      [columns]="4">
                      @if (LogData?.length > 0) {
                        @for(ModLogData of LogData; track $index;let i = $index){
                          <tr>
                            <td align="center">{{ i + 1 }}</td>
                            <td>{{ ModLogData.recAddDt | date : "dd-MMM-yyyy" }}</td>
                            <td [innerHTML]="ModLogData.ChangeDescr"></td>
                            <td>{{ ModLogData.UserName }}</td>
                          </tr>
                        }
                      }
                    </app-table-state>
                    </tbody>
                  </table>
                </div>
            } @else {
              <!-- <div class="col-sm-12 paddingles" style="max-height: 220px">
                <div class="col-sm-3">
                </div>
                <div class="col-sm-5"></div>
                <div class="col-sm-4"><br /></div>
                <br />
                <table class="LMtable" style="max-height: 200px; overflow-y: scroll; display: block">
                  <tr>
                    <th>S.No.</th>
                    <th>Date</th>
                    <th>Change Description</th>
                    <th>Updated By</th>
                  </tr>
                  <tr style="border: lightgray solid 1px" *ngFor="let ModLogData of LogData; let i = index">
                    <td align="center">{{ i + 1 }}</td>
                    <td width="82px">
                      {{ ModLogData.recAddDt | date : "dd-MMM-yyyy" }}
                    </td>
                    <td><span [innerHTML]="ModLogData.ChangeDescr"></span></td>
                    <td width="82px">{{ ModLogData.UserName }}</td>
                  </tr>
                </table>
              </div> -->
            }
          </div>
        </div>
        <!-- </div> -->
        <div class="col-sm-12">&nbsp;</div>
      </div>
    </div>
    <div>&nbsp;</div>
  </div>
</my-content>
<my-content placeholder="main"> </my-content>